(function() {
  'use strict';

  angular
    .module('eternaWeb2', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'toastr', 'pascalprecht.translate', 'ngStorage', 'angularMoment', 'daterangepicker', 'ngFileUpload', 'permission', 'permission.ui', 'thatisuday.ng-image-gallery', 'ngPrint', 'bw.paging', 'ngDialog']);

})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('TratamientoDatosController', TratamientoDatosController);

  /** @ngInject */
  function TratamientoDatosController($state, $scope, $stateParams, toastr, $filter, Config, Auth, AuthStorage, $localStorage, ngDialog, $timeout) {
	var vm = this;

  }
})();
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('TermsController', TermsController);

  /** @ngInject */
  function TermsController($state, $scope, $stateParams, toastr, $filter, Config, Auth, AuthStorage, $localStorage, ngDialog, $timeout) {
	var vm = this;

	vm.agree_checkbox = 1;
	vm.agree_checkbox_disable = true;

	vm.updateCheckbox =  function() {
		vm.agree_checkbox = 1;
	}
  }
})();
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('AvisoPrivacidadController', AvisoPrivacidadController);

  /** @ngInject */
  function AvisoPrivacidadController($state, $scope, $stateParams, toastr, $filter, Config, Auth, AuthStorage, $localStorage, ngDialog, $timeout) {
	var vm = this;

  }
})();
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('ShoppingCarController', ShoppingCarController);

  /** @ngInject */
  function ShoppingCarController($state, $scope, toastr, $filter, Config, Auth, AuthStorage, ShoppingCar, Orders, $localStorage, ngDialog, $timeout,ConfigSite) {
	var vm = this;

	vm.initialize = function() {
      vm.showLoading = false;
      vm.showLoadingDelete = false;
      vm.shoppingCarList = [];
      vm.newOrderList = [];
      vm.newOrderId = null;
      vm.ValorValidBuyerMax=25000;

      vm.alerts = {
          msg: '',
          accept_btn: 'Aceptar',
          cancel_btn: 'Declinar'
      };
      vm.getMinBuyerConfig();
      vm.getMyShoppingCar(true);
    };

    vm.calcTotalItem = function(price, amount) {
      return (price * amount);
    }

    vm.onChangeItemAmount = function(item) {
      $timeout(function(){
        var amountFinal = 1;
        if(item.amount > 0){
          if(item.amount > Config.ENV.PRODUCT_MAX_AMOUNT){
            amountFinal = Config.ENV.PRODUCT_MAX_AMOUNT;
          }else{
            amountFinal = item.amount;
          }
        }

        for(var i in vm.shoppingCarList){
          if(vm.shoppingCarList[i].id == item.id){
            vm.shoppingCarList[i].amount = amountFinal;
            vm.updateAmountOnline(vm.shoppingCarList[i].id, vm.shoppingCarList[i].amount);
          }
        }
      }, 1000);
    }

    vm.discountAmount = function(item) {
      if((item.amount - 1) > 0){
        for(var i in vm.shoppingCarList){
          if(vm.shoppingCarList[i].id == item.id){
            vm.shoppingCarList[i].amount = vm.shoppingCarList[i].amount - 1;
            vm.updateAmountOnline(vm.shoppingCarList[i].id, vm.shoppingCarList[i].amount);
          }
        }
      }
    }

    vm.incrementAmount = function(item) {
      if((item.amount + 1) <= Config.ENV.PRODUCT_MAX_AMOUNT){
        for(var i in vm.shoppingCarList){
          if(vm.shoppingCarList[i].id == item.id){
            vm.shoppingCarList[i].amount++;
            vm.updateAmountOnline(vm.shoppingCarList[i].id, vm.shoppingCarList[i].amount);
          }
        }
      }
    }

    vm.calcTotalShopping = function() {
      var total = 0;
      for(var i in vm.shoppingCarList){
        total += (vm.shoppingCarList[i].productReference.price * vm.shoppingCarList[i].amount);
      }

      return total;
    }

    vm.getMinBuyerConfig = function() {
      

      ConfigSite.getConfigSite()
        .then(function(response){
          if(response.monto_max){
            vm.ValorValidBuyerMax = response.monto_max;  

                     
          }

        })
        .catch(function (error) {

        });
      console.log("Validando: "+ vm.ValorValidBuyerMax)

      
    }

    vm.getMyShoppingCar = function(loading) {
      if(loading){
        vm.showLoading = true;
      }
      ShoppingCar.myShoppingCar()
        .then(function(response){
          vm.shoppingCarList = response.data;
          for(var i in vm.shoppingCarList){
            vm.shoppingCarList[i].amount=parseInt(vm.shoppingCarList[i].amount);
          }
          vm.showLoading = false;
        })
        .catch(function (error) {
            vm.showLoading = false;
        });
    }

    vm.updateAmountOnline = function(id, amount) {

      ShoppingCar.updateAmount(id, amount)
        .then(function(response){
          vm.getMyShoppingCar(false);
        });
    }

    vm.deleteItemFromShoppingCar = function(item) {
      for(var i in vm.shoppingCarList){
        if(vm.shoppingCarList[i].id == item.id){
          vm.shoppingCarList[i].loadingDelete = true;
        }else{
          vm.shoppingCarList[i].loadingDelete = false;
        }
      }
      ShoppingCar.deleteItemShoppingCar(item.id)
        .then(function(response){
          vm.getMyShoppingCar(false);
        });
    }

    vm.deleteAllShoppingCar = function() {
      vm.showLoadingDelete = true;
      ShoppingCar.deleteAllShoppingCar()
        .then(function(){
          vm.getMyShoppingCar(true);
          vm.showLoadingDelete = false;
        })
        .catch(function (error) {
            vm.showLoadingDelete = false;
        });
    }

    vm.goHome = function() {
      $state.go('private.home');
    }

    vm.processShoppingCar = function() {
      ngDialog.close();
      vm.showLoading = true;
      var newProductInOrder = {};
      var TotalorderValid=0;
      var TotalorderValidBuyerMax =0;

      TotalorderValid=parseInt(vm.calcTotalShopping());
      TotalorderValidBuyerMax=parseInt(vm.ValorValidBuyerMax);
      
        

      if(TotalorderValid < TotalorderValidBuyerMax){
         vm.alerts.msg = 'Valor mínimo de compra debe ser mayor a  $40.000 pesos.';
                  ngDialog.open({ template: 'app/shoppingcar/templates/error-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: $scope,
                                showClose: false });
                  vm.getMyShoppingCar();
      }else{

        for(var i in vm.shoppingCarList){
          newProductInOrder = {product: vm.shoppingCarList[i].productReference.id, amount: vm.shoppingCarList[i].amount};
          vm.newOrderList.push(newProductInOrder);
        }

        if(vm.newOrderList.length > 0){
          var params = {products: []};
          params.products = vm.newOrderList;

          Orders.createOrder(params)
            .then(function(response){
              if(response.data){
                if(response.data.id){
                  vm.newOrderId = response.data.id;

                  $localStorage.newOrder = JSON.stringify({id: vm.newOrderId});

                  ShoppingCar.deleteAllShoppingCar()
                    .then(function(response2){
                      $state.go('private.orderResume', {orderId: vm.newOrderId});
                    });


                }else{
                  vm.alerts.msg = 'Ha ocurrido un error, por favor inténtelo de nuevo';
                  ngDialog.open({ template: 'app/shoppingcar/templates/error-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: $scope,
                                showClose: false });
                }
              }else{
                vm.alerts.msg = 'Ha ocurrido un error, por favor inténtelo de nuevo';
                ngDialog.open({ template: 'app/shoppingcar/templates/error-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: $scope,
                                showClose: false });
              }
            })
            .catch(function (error) {
              vm.showLoading = false;
              vm.alerts.msg = error.data.message;
              ngDialog.open({ template: 'app/shoppingcar/templates/error-alert.html',
                                  className: 'ngdialog-theme-eterna',
                                  scope: $scope,
                                  showClose: false });
            });
        }
        
      }

    }

    vm.showConfirmProcessAlert = function() {
      vm.alerts.msg = 'Autorizo a Eterna S.A. descontar por nomina el valor soportado en la factura por concepto de Compra Online Portal Empleados Eterna; así mismo, en caso de retiro de la compañía, autorizo descontar de mis acreencias laborales u otro pago a mi favor, el saldo pendiente a la fecha de retiro.';
      ngDialog.open({ template: 'app/shoppingcar/templates/confirm-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: $scope,
                                showClose: false });
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($state, $scope, $stateParams, toastr, $filter, Config, Auth, AuthStorage, $localStorage, ngDialog, $timeout) {
	var vm = this;

	vm.initialize = function() {
    vm.fileSaving = false;
    vm.editData = false;
    vm.editPassword = false;
    vm.isSaving = false;

    vm.passwordData = {current: null, newpass: null, confirmpass: null};

    vm.alerts = {
        msg: '',
        accept_btn: 'Aceptar'
    };

    vm.getProfile();
  }

  vm.showAlert = function() {
      ngDialog.open({ template: 'app/profile/templates/profile-alert.html',
                              className: 'ngdialog-theme-eterna',
                              scope: $scope,
                              showClose: false });
  };

  vm.getProfile = function() {
    vm.showLoading = true;
    vm.profileData = AuthStorage.getCurrentUser();

    console.log(vm.profileData);
  }

  vm.uploadImgProfile = function(file, invalidFiles) {
      if (file) {
        // Loading
        vm.fileSaving = true;

        // Upload
        var params = {
            id: vm.profileData.id,
            pic: file
        };
        Auth.uploadMyPic(params)
            .then(function(response) {
              if(response.data){
                vm.profileData.url = response.data.url;
                AuthStorage.setCurrentUser(vm.profileData);
              }

                // Loading
                vm.fileSaving = false;
            })
            .catch(function(error) {
                // Loading
                vm.fileSaving = false;
                vm.alerts.msg = 'Hubo un error al cambiar la imagen, por favor verifique que sea un archivo correcto.';
                vm.showAlert();
            });
    }
    };

    vm.toggleEdit = function() {
      vm.editData = !vm.editData;

      if(vm.editData){
        vm.profileDataCopy = angular.copy(vm.profileData);
      }
    }

    vm.toggleEditPassword = function() {
      vm.editPassword = !vm.editPassword;

      vm.passwordData.current = null;
      vm.passwordData.newpass = null;
      vm.passwordData.confirmpass = null;
    }

    vm.updatePasswordData = function(passwordFormName) {
      vm.isSaving = true;
      // Valid form?
        if (passwordFormName.$invalid) {

            // Email
            if (passwordFormName.$error.required) {
              vm.alerts.msg = 'Por favor ingrese la actual y nueva contraseña';
              vm.showAlert();
            }else{
              vm.alerts.msg = 'Ha ocurrido un error por favor verifique sus datos';
              vm.showAlert();
            }
            vm.isSaving = false;
            return;
        }

        if(vm.passwordData.newpass != vm.passwordData.confirmpass){
          vm.alerts.msg = 'Las contraseñas no coinciden';
          vm.showAlert();
          vm.isSaving = false;
          return;
        }

        if(vm.passwordData.newpass.length < 8){
          vm.alerts.msg = 'La contraseña debe tener una longitud minima de 8 carácteres';
          vm.showAlert();
          vm.isSaving = false;
          return;
        }

        var params = {};
        params.current = vm.passwordData.current;
        params.newpass = vm.passwordData.newpass;
        params.confirmpass = vm.passwordData.confirmpass;

        Auth.changePassword(params)
                .then(function(response) {
                    if(response.data){
                      vm.alerts.msg = 'Contraseña cambiada correctamente';
                      vm.showAlert();

                      $timeout(function(){
                        ngDialog.close();
                        Auth.logout();
                        $state.go('public.login');
                      }, 2000);
                    }
                    vm.toggleEditPassword();
                    vm.isSaving = false;
                })
                .catch(function(error) {
                  console.log(error);
                  vm.alerts.msg = error.data.message;
                  vm.showAlert();
                    //toastr.error(error.message);
                    vm.isSaving = false;
                });
    }

    vm.updateDataDelivery = function(userFormName) {
      vm.isSaving = true;
      // Valid form?
        if (userFormName.$invalid) {

            // Email
            if (userFormName.$error.required) {
              vm.alerts.msg = 'Por favor ingrese todos sus datos';
              vm.showAlert();
                //toastr.error('Por favor ingrese todos sus datos');
                return;
            }else{
              vm.alerts.msg = 'Ha ocurrido un error por favor verifique sus datos';
              vm.showAlert();
                //toastr.error('Ha ocurrido un error por favor verifique sus datos');
            }
            vm.isSaving = false;
            return;
        }

        var params = {};
        params.id = vm.profileDataCopy.id;
        params.password = vm.profileDataCopy.id;
        params.telephone = vm.profileDataCopy.telephone;
        params.cellphone = vm.profileDataCopy.cellphone;
        params.email = vm.profileDataCopy.email;
        params.delivery_address = vm.profileDataCopy.delivery_address;
        params.delivery_city = vm.profileDataCopy.delivery_city;
        params.delivery_country = vm.profileDataCopy.delivery_country;

        Auth.updateProfile(params)
                .then(function(response) {
                    if(response.data){
                      vm.profileData = response.data;
                      AuthStorage.setCurrentUser(vm.profileData);
                      vm.alerts.msg = 'Datos actualizados correctamente';
                      vm.showAlert();
                      //toastr.success('Datos actualizados correctamente');
                    }
                    vm.toggleEdit();
                    vm.isSaving = false;
                })
                .catch(function(error) {
                  vm.alerts.msg = error.message;
                  vm.showAlert();
                    //toastr.error(error.message);
                    vm.isSaving = false;
                });
    }

    vm.initialize();
  }
})();
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('ProductDetailsController', ProductDetailsController);

  /** @ngInject */
  function ProductDetailsController($state, $scope, $stateParams, toastr, $filter, Config, Auth, AuthStorage, ShoppingCar, Product, $localStorage, ngDialog) {
	var vm = this;

	vm.initialize = function() {
    vm.showLoading = true;
    vm.productId = $stateParams.id|| null;
    vm.previousPage = $stateParams.page|| null;
    console.log(vm.previousPage);
    vm.productInfo = null;
    vm.isAdding = false;

    vm.attributesChoosed = [];

    vm.alerts = {
                  msg: '',
                  accept_btn: 'Aceptar'
              };

    if(vm.productId){
      vm.getProductById();
    }else{
      vm.showLoading = false;
    }

    
    };

  vm.getProductById = function() {
    Product.getProductId(vm.productId)
      .then(function(response){
        vm.productInfo = response.data;
        vm.showLoading = false;
        if(vm.productInfo.attributes.length){
          for(var i in vm.productInfo.attributes) {
            vm.attributesChoosed.push({valor: vm.productInfo.attributes[i].valores[0].id.toString()});
          }
        }
      })
      .catch(function(error){
        vm.showLoading = false;
      });
  }

  vm.addShoppingCart = function() {
    vm.isAdding = true;
    var productAttributes = [];
    for(var i in vm.attributesChoosed){
      productAttributes.push(vm.attributesChoosed[i].valor);
    }
    //if (!vm.productInfo.isInShoppingCar) {
      var productItem = vm.productInfo;
      ShoppingCar.addProduct({ product_id: vm.productInfo.id, product_attr: productAttributes, amount: 1 })
        .then(function(response){
          toastr.success("Producto agregado al carrito");
          vm.isAdding = false;
          vm.productInfo = response.data.product;
        })
        .catch(function(error){
          vm.isAdding = false;
          if(error.data){
            if(error.data.message){
              vm.alerts.msg = error.data.message;
              vm.showAlert();
            }
          }
        });
    /*}else{
      vm.isAdding = false;
    }*/
  }

  vm.showAlert = function() {
      ngDialog.open({ template: 'app/products/templates/product-details-alert.html',
                              className: 'ngdialog-theme-eterna',
                              scope: $scope,
                              showClose: false });
  }

  vm.returnProductPage = function() {
    $state.go('private.home', {page: vm.previousPage});
  }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('OrdersController', OrdersController);

  /** @ngInject */
  function OrdersController($state, $stateParams, toastr, $filter, Config, Auth, AuthStorage, ShoppingCar, Orders, $localStorage) {
	var vm = this;

	vm.initialize = function() {
    vm.orderStatusList = [{id: 'all', name: 'Todos'},
                          {id: 'pending', name: 'Pendiente'},
                          //{id: 'delivered', name: 'Entregada'},
                          {id: 'paid', name: 'Pagada'}];
    vm.orderStatusSelected = 'all';
    vm.paramsOrders = {
      page: 1,
      limit: 10,
      status: vm.orderStatusSelected
    };

    vm.ordersPaging = {
      total: 0,
      total_pages: 0,
      per_page: 0,
      current_page: 1
    };

    vm.getOrderList();
  }

  vm.updateOrdersStatusSelect = function() {
    vm.paramsOrders.status = vm.orderStatusSelected;
    vm.paramsOrders.page = 1;
    vm.getOrderList(); 
  }

  vm.getOrderList = function() {
    vm.showLoading = true;
    Orders.getMyOrders(vm.paramsOrders)
      .then(function(response){
        vm.orderList = response.data;
        for(var i in vm.orderList){
          vm.orderList[i].statusText = '--';
          switch(vm.orderList[i].status){
            case 'pending':
              vm.orderList[i].statusText = 'Pendiente';
              break;
            /*case 'delivered':
              vm.orderList[i].statusText = 'Entregada';
              break;*/
            case 'paid':
              vm.orderList[i].statusText = 'Pagada';
              break;
          }
        }

        if(angular.isDefined(response.pagination)){
          vm.ordersPaging.total = response.pagination.total;
          vm.ordersPaging.total_pages = response.pagination.total_pages;
          vm.ordersPaging.per_page = response.pagination.per_page;
          vm.ordersPaging.current_page = response.pagination.current_page;
        }

        vm.showLoading = false;
      })
      .catch(function(error){
        vm.showLoading = false;
      });
  }


  vm.toggleShowDetails = function(order) {
    for(var i in vm.orderList){
      if(vm.orderList[i].id == order.id){
        vm.orderList[i].expanded = !vm.orderList[i].expanded;
      }else{
        vm.orderList[i].expanded = false;
      }
    }
  }

  vm.goPage = function(action, page) {
    if(action == 'pageClicked'){
      if(page > 0 && page <= vm.ordersPaging.total_pages && page != vm.ordersPaging.current_page){
        vm.paramsOrders.page = page;
        vm.getOrderList();
      }
    }
  }

    vm.initialize();
  }
})();
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('OrderViewController', OrderViewController);

  /** @ngInject */
  function OrderViewController($state, $stateParams, toastr, $filter, Config, Auth, AuthStorage, ShoppingCar, Orders, $localStorage) {
	var vm = this;

	vm.initialize = function() {
    vm.showLoading = true;
    vm.orderId = $stateParams.orderId|| null;
    vm.orderInfo = null;
    vm.isBuy = false;

    if(vm.orderId){
      var lastBuy = angular.isDefined($localStorage.newOrder) ? $localStorage.newOrder : false;

      vm.isBuy = lastBuy ? true : false;
      vm.getOrderById()
    }

    vm.showLoading = false;
    };

  vm.getOrderById = function() {
    Orders.getOrderId(vm.orderId)
      .then(function(response){
        vm.orderInfo = response.data;
        vm.showLoading = false;
      })
      .catch(function(error){
        vm.showLoading = false;
      });
  }

    vm.initialize();
  }
})();

'use strict';
angular.module('eternaWeb2')
    .service('ShoppingCar', function (Config, $q, $http, AuthStorage)
    {

        this.addProduct = function(params)
        {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/shopping_cart', params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (error) {
                    q.reject(error);
                });
                
            return q.promise;  
        }

        /**
         * Get my shopping car
         */
        this.myShoppingCar = function() {
            var q = $q.defer();

            $http.get(Config.ENV.API_ENDPOINT + '/shopping_cart')
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }

        /**
         * Update amount of product in shopping cart
         */
        this.updateAmount = function(id, amount) {
            var q = $q.defer();

            var params = { id: id, amount: amount };

            $http.post(Config.ENV.API_ENDPOINT + '/shopping_cart/update/'+id, params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }

        /**
         * Delete one item from shopping car
         */
        this.deleteItemShoppingCar = function(id) {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/shopping_cart/delete/'+id, {})
                .then(function (response) {
                    q.resolve(response);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }

        /**
         * Delete all items from shopping car
         */
        this.deleteAllShoppingCar = function() {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/shopping_cart/delete', {})
                .then(function (response) {
                    q.resolve(response);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }


    });

'use strict';
angular.module('eternaWeb2')
    .service('Product', function (Config, $q, $http, AuthStorage)
    {
        this.getAll = function (params)
        {
            var q = $q.defer();

            if (!params.page) {
                params.page = 1;
            }
            if (!params.limit) {
                params.limit = 50;
            }

            var config = {
             params: params
            };

            $http.get(Config.ENV.API_ENDPOINT + '/products', config)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };

        /**
         * Get product id
         */
        this.getProductId = function(id) {
            var q = $q.defer();

            $http.get(Config.ENV.API_ENDPOINT + '/products/'+id)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }


    });

'use strict';
angular.module('eternaWeb2')
    .service('Orders', function (Config, $q, $http, AuthStorage)
    {

        /**
         * Get my order list
         */
        this.getMyOrders = function(params) {
            var q = $q.defer();

            if (!params.page) {
                params.page = 1;
            }
            if (!params.limit) {
                params.limit = 10;
            }

            var config = {
             params: params
            };

            $http.get(Config.ENV.API_ENDPOINT + '/orders', config)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }

        /**
         * Get order id
         */
        this.getOrderId = function(id) {
            console.log(id);
            var q = $q.defer();

            $http.get(Config.ENV.API_ENDPOINT + '/orders/'+id)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }

        /**
         * Create order
         */
        this.createOrder = function(params) {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/orders', params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(response);
                });
                
            return q.promise;
        }

        this.testOrder = function(id) {
            return id;
        }
    });

'use strict';
angular.module('eternaWeb2')
    .service('ConfigSite', function (Config, $q, $http, AuthStorage)
    {
        this.getConfigSite = function ()
        {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/config/active')
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };


    });

'use strict';
angular.module('eternaWeb2')
    .service('CategoryGroup', function (Config, $q, $http, AuthStorage)
    {
        this.getAll = function (params)
        {
            var q = $q.defer();

            if (!params.page) {
                params.page = 1;
            }
            if (!params.limit) {
                params.limit = 10;
            }

            var config = {
             params: params
            };

            $http.get(Config.ENV.API_ENDPOINT + '/category_group', config)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };


    });

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('PublicController', PublicController);

  /** @ngInject */
  function PublicController($scope, $rootScope, $state) {
	var vm = this;

    vm.isPublicPage = true;

    $scope.$watch(function() {
      return $rootScope.siteEnable;
    }, function() {
      if(!$rootScope.siteEnable){
        $state.go('public2.disable');
      }
    }, true);
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('PrivateController', PrivateController);

  /** @ngInject */
  function PrivateController($scope, $rootScope, $state) {
	var vm = this;

    vm.isPublicPage = false;

    $scope.$watch(function() {
      return $rootScope.siteEnable;
    }, function() {
      if(!$rootScope.siteEnable){
        $state.go('public2.disable');
      }
    }, true);
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('productItem', ProductItem);

  /** @ngInject */
  function ProductItem($rootScope, toastr, ShoppingCar, $state, $timeout, ngDialog) {
    return {
        templateUrl: 'app/main/templates/directives/product-item.html',
        restrict: 'E',
        replace: true,
        scope: {
          product: '=',
          page: '=',
          reloadParent: '&'
        },
        link: function(scope) {

            scope.isAdded = false;
            scope.isAdding = false;
            scope.attributesChoosed = [];
            /**
             * Initialize
             */
            scope.initialize = function() {

              scope.alerts = {
                  msg: '',
                  accept_btn: 'Aceptar'
              };

              /*if(scope.product.isInShoppingCar){
                scope.isAdded = scope.product.isInShoppingCar;
              }*/
              //scope.product.price=;

              if(scope.product.attributes.length){
                for(var i in scope.product.attributes) {
                  scope.attributesChoosed.push({valor: scope.product.attributes[i].valores[0].id.toString()});
                }
              }
            };

            scope.addShoppingCart = function() {
              scope.isAdding = true;
              var productAttributes = [];
              for(var i in scope.attributesChoosed){
                productAttributes.push(scope.attributesChoosed[i].valor);
              }
              //if (!scope.product.isInShoppingCar) {
                var productItem = scope.product;
                ShoppingCar.addProduct({ product_id: scope.product.id, product_attr: productAttributes, amount: 1 })
                  .then(function(response){
                    toastr.success("Producto agregado al carrito");
                    scope.isAdded = true;
                    scope.isAdding = false;
                    productItem = response.data.product;
                    scope.reloadParent({productItem: productItem});
                  })
                  .catch(function(error){
                    scope.isAdding = false;
                    if(error.data){
                      if(error.data.message){
                        scope.alerts.msg = error.data.message;
                        scope.showAlert();
                      }
                    }
                  });
              /*}else{
                scope.isAdding = false;
              }*/
            }

            scope.showAlert = function() {
                ngDialog.open({ template: 'app/products/templates/product-alert.html',
                                        className: 'ngdialog-theme-eterna',
                                        scope: scope,
                                        showClose: false });
            }

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('orderDetails', OrderDetails);

  /** @ngInject */
  function OrderDetails($rootScope, Orders, $state, $timeout) {
    return {
        templateUrl: 'app/main/templates/directives/order-details.html',
        restrict: 'E',
        replace: true,
        scope: {
          order: '='
        },
        link: function(scope) {

            
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('ngEnter', NgEnter);

  /** @ngInject */
  function NgEnter($state, $stateParams) {
    return function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
            if(event.which === 13) {
                console.log("heyyy si");
                scope.$apply(function(){
                  console.log("heyyy otra vez");
                    scope.$eval(attrs.ngEnter, {'event': event});
                });

                event.preventDefault();
            }
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('loading', Loading);

  /** @ngInject */
  function Loading($rootScope, $state, $timeout) {
    return {
        templateUrl: 'app/main/templates/directives/loading.html',
        restrict: 'E',
        replace: true,
        scope: {
          displayasrow: '=',
          hasbackground: '=',
          block: '=',
          size: '='
        },
        link: function(scope) {
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('appHeader', AppHeader);

  /** @ngInject */
  function AppHeader($rootScope, Auth, AuthStorage, $state, $timeout, ngDialog) {
    return {
        templateUrl: 'app/main/templates/directives/app-header.html',
        restrict: 'E',
        replace: true,
        scope: {},
        link: function(scope) {
            /**
             * Initialize
             */
            scope.initialize = function() {
                
              scope.user = AuthStorage.getCurrentUser();
              scope.isAuthenticated = AuthStorage.isAuthenticated();
              scope.isSiteEnable = $rootScope.siteEnable;
            };

            scope.logout = function() {
              ngDialog.close();
              Auth.logout();
              $state.go('public.login');
            };

            scope.logoutAlert = function() {
              ngDialog.open({ template: 'app/main/templates/directives/logout-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: scope,
                                showClose: false });
            }

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('appFooter', AppFooter);

  /** @ngInject */
  function AppFooter($rootScope, $state, $timeout) {
    return {
        templateUrl: 'app/main/templates/directives/app-footer.html',
        restrict: 'E',
        replace: true,
        scope: {},
        link: function(scope) {
            /**
             * Initialize
             */
            scope.initialize = function() {
                
            };

            scope.goAvisoPrivacidad = function() {
              $state.go('public2.avisoprivacidad');
            };

            scope.goTratamientoDatos = function() {
              $state.go('public2.tratamientodatos');
            };

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($state, $stateParams, toastr, $filter, Config, Auth, AuthStorage, CategoryGroup, Product, $rootScope, $scope, $timeout,ConfigSite) {
	var vm = this;

	vm.initialize = function() {
        vm.pageRequest = $stateParams.page|| null;
        vm.categoryGroupList = [];
        vm.productList = [];
        vm.categoryGroupSelected = "";
        vm.categorySelected = "";
        vm.categoriesSelect = [];
        vm.legalPromo="";
        vm.bannerWeb="";
        vm.bannerMobile="";
        vm.msjPromociones=""
        
        vm.params = {
          page: 1,
          limit: 9999
        };

        vm.paramsProducts = {
          page: (vm.pageRequest) ? vm.pageRequest : 1,
          limit: 50,
          category: null,
          q: null
        };

        vm.productsPaging = {
          total: 0,
          total_pages: 0,
          per_page: 0,
          current_page: 1
        };

        vm.showLoadingGroup = false;
        vm.showLoadingProducts = false;
        vm.getInfoConfig();
        vm.getcategoryGroups();
        vm.getProducts();
    };


    vm.getInfoConfig = function(){
        ConfigSite.getConfigSite()
        .then(function(response){
          if(response.banner_welcome_web){
            vm.bannerWeb = response.banner_welcome_web;            
          }

          if(response.banner_welcome_mobile){
            vm.bannerMobile = response.banner_welcome_mobile;            
          }

          if(response.msj_promociones){
            vm.msjPromociones = response.msj_promociones;            
          }
          


        })
        .catch(function (error) {

        });
    }
    /**
    * Get category groups
    */
    vm.getcategoryGroups = function() {
      this.showLoadingGroup = true;
      CategoryGroup.getAll(this.params)
        .then(function(response){
            vm.categoryGroupList = response.data;

            for(var i in vm.categoryGroupList){
              vm.categoryGroupList[i].expanded = false;
            }
            vm.showLoadingGroup = false;
        })
        .catch(function (error) {
            vm.showLoadingGroup = false;
        });
    }

    vm.getProductsFromCat = function(cat_id) {
      
      if(cat_id==11){
        vm.legalPromo=vm.msjPromociones;
      }else{
        vm.legalPromo="";

      }

      vm.paramsProducts.category = cat_id;
      for(var i in this.categoryGroupList){
        for(var j in this.categoryGroupList[i].categories){
          if(this.categoryGroupList[i].categories[j].id == cat_id){
            this.categoryGroupList[i].categories[j].activeDom = true;
          }else{
            this.categoryGroupList[i].categories[j].activeDom = false;
          }
        }
      }
      vm.getProducts();
    }

    /**
    * Get products
    */
    vm.getProducts = function() {
        this.showLoadingProducts = true;
        Product.getAll(this.paramsProducts)
            .then(function(response){
                vm.productList = response.data;

                if(angular.isDefined(response.pagination)){
                  vm.productsPaging.total = response.pagination.total;
                  vm.productsPaging.total_pages = response.pagination.total_pages;
                  vm.productsPaging.per_page = response.pagination.per_page;
                  vm.productsPaging.current_page = response.pagination.current_page;
                }

                vm.showLoadingProducts = false;
            })
            .catch(function (error) {
                vm.showLoadingProducts = false;
            });
    }

    vm.updateProductItem = function(productItem) {
      if(angular.isDefined(productItem.id)){
        for(var i in this.productList){
          if(this.productList[i].id == productItem.id){
            this.productList[i] =  productItem;
          }
        }
      }
    }

    vm.enterGetProducts = function() {
      vm.getProducts();
    }

    vm.updateCategoriesSelect = function() {
      vm.categoriesSelect = [];

      for(var i in vm.categoryGroupList){
        if(vm.categoryGroupList[i].id == vm.categoryGroupSelected){
          vm.categoriesSelect = vm.categoryGroupList[i].categories;
        }
      }
    }

    vm.sendCategorySelected = function() {
      if(vm.categorySelected != 0 && vm.categorySelected != "0" && vm.categorySelected != ""){
        vm.getProductsFromCat(vm.categorySelected);
      }
    }

    vm.goPage = function(action, page) {
      if(action == 'pageClicked'){
        if(page > 0 && page <= vm.productsPaging.total_pages && page != vm.productsPaging.current_page){
          vm.paramsProducts.page = page;
          vm.getProducts();
        }
      }
    }

    vm.toggleCategory = function(group) {
      if(!group.expandedClick){
        group.expandedClick = true;
        group.expanded = !group.expanded;
      }

      $timeout(function () { group.expandedClick = false; }, 500);
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  angular
      .module('eternaWeb2')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

'use strict';
angular.module('eternaWeb2')
    .service('AuthInterceptor', function ($q, AuthStorage)
    {
        
        return {
            request: function (cfg)
            {
                cfg.headers = cfg.headers || {};

                var customHeaders = {
                    headers: {
                        "Authorization": "",
                        "Content-Type": "application/json"
                    }
                };

                //Get Access Token.
                //$localStorage.$apply();
                var currentTokens = AuthStorage.getCurrentTokens();
                if (currentTokens && currentTokens.access_token && currentTokens.token_type) {
                    customHeaders.headers["Authorization"] = currentTokens.token_type + ' ' + currentTokens.access_token;
                }

                //Allow us to override the Interceptor configurtion, sending the headers at a http request.
                cfg.headers = angular.extend(customHeaders.headers, cfg.headers);

                return cfg;

            },
            responseError: function(response) {
                return $q.reject(response);
            }
        };

    });

angular.module('eternaWeb2')
    .config(['$httpProvider',
        function ($httpProvider)
        {

            $httpProvider.interceptors.push('AuthInterceptor');

        }]);

'use strict';
angular.module('eternaWeb2')
    .service('Auth', function (Config, $q, $http, AuthStorage, Upload)
    {
        this.login = function (params)
        {
            var q = $q.defer();

            var body = {
                grant_type: Config.ENV.API_GRANT_TYPE,
                client_id: Config.ENV.API_CLIENT_ID,
                client_secret: Config.ENV.API_CLIENT_SECRET,
                username: params.username,
                password: params.password
            };

            $http.post(Config.ENV.API_ENDPOINT + '/oauth/token', body)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (error) {
                    q.reject(error);
                });

            return q.promise;
        };

        this.getUserByCredentials = function(params)
        {
            var q = $q.defer();

            var body = {
                username: params.username,
                password: params.password
            };

            $http.post(Config.ENV.API_ENDPOINT + '/userGetInfo', body)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (error) {
                    q.reject(error);
                });

            return q.promise;   
        }

        this.uploadMyPic = function(params)
        {
        // Defer
            var defer = $q.defer();
            // Url
            var url = Config.ENV.API_ENDPOINT + '/user/setMyPicImg';

            // Get
            Upload.upload({url: url, data: params})
              .then(function(response) {
                    // Success
                    defer.resolve(response.data);
                })
                .catch(function(response) {
                    // Error

                    defer.reject(false);
                });

            return defer.promise; 
        }

        /**
         * Update profile data
         */
        this.updateProfile = function(params) {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/user/update/'+params.id, params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });
                
            return q.promise;
        }

        /**
         * Change password
         */
        this.changePassword = function(params) {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT + '/user/changepassword', params)
                .then(function (response) {
                    q.resolve(response);
                })
                .catch(function (error) {
                    q.reject(error);
                });
                
            return q.promise;
        }

        this.rememberPassword = function (params)
        {
            var q = $q.defer();

            var body = {
                email: params.email
            };

            $http.post(Config.ENV.API_ENDPOINT + '/user/rememberpassword', body)
                .then(function (response) {
                    q.resolve(response);
                })
                .catch(function (error) {
                    q.reject(error);
                });

            return q.promise;
        };

        this.logout = function ()
        {
            AuthStorage.logout();

            return true;   
        };


    });

'use strict';
angular.module('eternaWeb2')
    .service('AuthStorage', function (Config, $localStorage)
    {
    	/**
	     * Sets the current user
	     */
	    this.setCurrentUser = function(user) {
	    	$localStorage.currentUser = JSON.stringify(user);
	    }

	    /**
	     * Gets the current user
	     */
	    this.getCurrentUser = function() {
	    	var currentUser = angular.isDefined($localStorage.currentUser) ? JSON.parse($localStorage.currentUser) : null;

	        return currentUser;
	    }

	    this.setExpired = function(expiredValue) {
	        $localStorage.expired = JSON.stringify({expired: expiredValue});
	    }

	    this.getExpired =  function() {
	        var expired = angular.isDefined($localStorage.expired) ? JSON.parse($localStorage.expired) : {expired: false};

	        return expired;
	    }

	    /**
	     * Removes the current user
	     */
	    this.removeCurrentUser = function() {
	        $localStorage.remove('currentUser');
	    }

	    /**
	     * Sets the current tokens
	     */
	    this.setCurrentTokens = function(tokens) {
	        $localStorage.currentTokens = JSON.stringify(tokens);
	    }

	    /**
	     * Gets the current tokens
	     */
	    this.getCurrentTokens =  function() {
	        var currentTokens = angular.isDefined($localStorage.currentTokens) ? JSON.parse($localStorage.currentTokens) : null;

	        return currentTokens;
	    }

	    /**
	     * Removes the current tokens
	     */
	    this.removeCurrentTokens = function() {
	        $localStorage.remove('currentTokens');
	    }

	    /**
	     * Is authenticated
	     */
	    this.isAuthenticated =  function() {
	        return this.getCurrentTokens() !== null && this.getCurrentUser() !== null;
	    }

	    /**
	     * Logout
	     */
	    this.logout = function() {
	    	$localStorage.$reset();
	    }
    });
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('RememberPasswordController', RememberPasswordController);

  /** @ngInject */
  function RememberPasswordController($state, $scope, toastr, $filter, Config, Auth, AuthStorage, ngDialog, $rootScope) {
	var vm = this;

	vm.initialize = function() {

        vm.alerts = {
            msg: '',
            accept_btn: 'Aceptar'
        };

        // Credentials
        vm.credentials = {
            username: null
        };
    };

    vm.showAlert = function() {
        ngDialog.open({ template: 'app/auth/templates/remember-password-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: $scope,
                                showClose: false });
    };

    vm.sendEmail = function (rememberPassFormName)
    {
        // Valid form?
        if (rememberPassFormName.$invalid) {

            // Email
            if (rememberPassFormName.$error.required) {
                vm.alerts.msg = 'Por favor ingrese su e-mail';
                vm.showAlert();
                //toastr.error('Por favor ingrese su e-mail');
                return;
            }else{
                vm.alerts.msg = 'Ha ocurrido un error por favor verifique su e-mail';
                vm.showAlert();
                //toastr.error('Ha ocurrido un error por favor verifique su e-mail');
            }

            return;
        }

        var params = {};
        params.email = vm.credentials.username;

        Auth.rememberPassword(params)
                .then(function(response) {
                    if(response.statusText == 'OK'){
                        vm.alerts.msg = 'Se ha enviado un mensaje a su e-mail recordando su contraseña';
                        vm.showAlert();
                        //toastr.success('Se ha enviado un mensaje a su e-mail recordando su contraseña');
                        $state.go('public.login');
                    }else{
                        vm.alerts.msg = 'Ha ocurrido un error por favor intentelo de nuevo';
                        vm.showAlert();
                        //toastr.error('Ha ocurrido un error por favor intentelo de nuevo.');
                    }
                })
                .catch(function(error) {
                    vm.alerts.msg = error.message;
                    vm.showAlert();
                    //toastr.error(error.message);
                });

        
    };

    vm.returnLogin = function() {
        $state.go('public.login');
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, $scope, toastr, $filter, Config, Auth, AuthStorage, ngDialog, $rootScope) {
	var vm = this;

	vm.doLogin = function (loginFormName)
    {
        vm.showLoading = true;
        // Valid form?
        if (loginFormName.$invalid) {

            // Email
            if (loginFormName.$error.required) {
                vm.alerts.msg = $filter('translate')('login:required:error');
                vm.showAlert();
                //toastr.error($filter('translate')('login:required:error'));
            }else{
                vm.alerts.msg = $filter('translate')('login:invalid:error');
                vm.showAlert();
            }

            vm.showLoading = false;

            return;
        }

        var params = {};
        params.username = vm.credentials.username;
        params.password = vm.credentials.password;

        Auth.login(params)
                .then(function(response) {
                    if (response.access_token) {
                        AuthStorage.setCurrentTokens({
                            access_token: response.access_token,
                            expires_in: response.expires_in,
                            refresh_token: response.refresh_token,
                            token_type: response.token_type,
                        });
                    }

                    // sets the current user
                    if (response.user) {
                        AuthStorage.setCurrentUser(response.user);
                        vm.showLoading = false;
                        $state.go('private.terms');
                    }else{
                        Auth.getUserByCredentials(params)
                            .then(function(response){
                                vm.showLoading = false;
                                if(response.user){
                                    AuthStorage.setCurrentUser(response.user);
                                    $state.go('private.terms');
                                }
                            });
                    }
                })
                .catch(function(error) {
                    vm.alerts.msg = "Error de usuario y/o contraseña, verifique sus datos.";
                    vm.showAlert();
                    vm.showLoading = false;
                    //toastr.error("Error de usuario y/o contraseña, verifique sus datos.");
                });

    	
    };

	vm.initialize = function() {

        vm.alerts = {
            msg: '',
            accept_btn: 'Aceptar'
        };

        // Credentials
        vm.credentials = {
            username: null,
            password: null
        };

        vm.showLoading = false;
    };

    vm.showAlert = function() {
        ngDialog.open({ template: 'app/auth/templates/auth-alert.html',
                                className: 'ngdialog-theme-eterna',
                                scope: $scope,
                                showClose: false });
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('DisableController', DisableController);

  /** @ngInject */
  function DisableController($state, $scope, toastr, $filter, Config, Auth, AuthStorage, ngDialog, $rootScope) {
	var vm = this;

	vm.disableDays = $rootScope.siteEnableDays;

    $scope.$watch(function() {
      return $rootScope.siteEnableDays;
    }, function() {
      vm.disableDays = $rootScope.siteEnableDays;
    }, true);

    $scope.$watch(function() {
      return $rootScope.siteEnable;
    }, function() {
      if($rootScope.siteEnable){
        $state.go('public.login');
      }
    }, true);
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1523737233857;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .run(initialize);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

  function initialize($rootScope, amMoment, $translate, PermPermissionStore, PermRoleStore, ConfigSite) {
    $translate.refresh();
  	/**
     * Moment
     */
    moment.locale('en', {
        relativeTime: {
            future: "%s left",
            past: "%s ago",
            s: "seconds",
            m: "1 minute",
            mm: "%d minutes",
            h: "1 hour",
            hh: "%d hours",
            d: "1 day",
            dd: "%d days",
            M: "1 month",
            MM: "%d months",
            y: "1 year",
            yy: "%d years"
        }
    });
    moment.locale('es', {
        relativeTime: {
            future: "%s left",
            past: "%s ago",
            s: "seconds",
            m: "1 minute",
            mm: "%d minutes",
            h: "1 hour",
            hh: "%d hours",
            d: "1 day",
            dd: "%d days",
            M: "1 month",
            MM: "%d months",
            y: "1 year",
            yy: "%d years"
        }
    });
  	var currentLang = $translate.proposedLanguage() || $translate.use();
    amMoment.changeLocale(currentLang);

    $rootScope.siteEnable = true;
    $rootScope.siteEnableDays = 0;
    $rootScope.siteEnableDays = "";

    
    ConfigSite.getConfigSite()
        .then(function(response){
          if(response.is_active == 0){
            $rootScope.siteEnable = false;
          }

          if(response.active_days){
            $rootScope.siteEnableDays = response.active_days;
          }

          if(response.banner_welcome_web){
            $rootScope.banner_welcome_web = response.banner_welcome_web;
          }


        })
        .catch(function (error) {

        });

    if(/Android/.test(navigator.appVersion)) {
       window.addEventListener("resize", function() {
         if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
           document.activeElement.scrollIntoView();
         }
      })
    } 

    /**
     * Permissions
     *
    PermRoleStore
      .defineManyRoles({
        'CARRIER':  function (rol) { return Auth.getUserProfile() == 'CARRIER'; },
        'GENERADOR_CARGA':  function (rol) { return Auth.getUserProfile() == 'GENERADOR_CARGA'; },
        'DRIVER':  function (rol) { return Auth.getUserProfile() == 'DRIVER'; }
      });*/
  }

})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .config(routeConfig);

  function routeConfig($stateProvider, $urlRouterProvider) {
    /*$routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .otherwise({
        redirectTo: '/'
      });*/

      $urlRouterProvider.otherwise('/login');

    /**
     * Routes
     */
    $stateProvider
        .state('public', {
                url: '',
                abstract: true,
                cache: false,
                views: {
                    'app': {
                        templateUrl: 'app/main/templates/layouts/public.html',
                        controller: 'PublicController',
                        controllerAs: 'public'
                    }
                },
                resolve: {
                    skipIfLoggedIn: skipIfLoggedIn
                }
            }
        )
        .state('public2', {
                url: '',
                abstract: true,
                cache: false,
                views: {
                    'app': {
                        templateUrl: 'app/main/templates/layouts/public.html',
                        controller: 'PublicController',
                        controllerAs: 'public'
                    }
                }
            }
        )
        .state('private', {
                url: '',
                abstract: true,
                cache: false,
                views: {
                    'app': {
                        templateUrl: 'app/main/templates/layouts/private.html',
                        controller: 'PrivateController',
                        controllerAs: 'private'
                    }
                },
                resolve: {
                    loginRequired: loginRequired
                }
            }
        )
        .state('public.login', {
                url: '/login',
                cache: false,
                views: {
                    'container@public': {
                        templateUrl: 'app/auth/templates/login.html',
                        controller: 'LoginController',
                        controllerAs: 'login'
                    }
                }
            }
        )
        .state('public.remember_password', {
                url: '/rememberpassword',
                cache: false,
                views: {
                    'container@public': {
                        templateUrl: 'app/auth/templates/remember_password.html',
                        controller: 'RememberPasswordController',
                        controllerAs: 'rememberpass'
                    }
                }
            }
        )
        .state('public2.disable', {
                url: '/disable',
                cache: false,
                views: {
                    'container@public2': {
                        templateUrl: 'app/auth/templates/disable.html',
                        controller: 'DisableController',
                        controllerAs: 'disablepage'
                    }
                }
            }
        )
        .state('public2.tratamientodatos', {
                url: '/tratamientodedatos',
                cache: false,
                views: {
                    'container@public2': {
                        templateUrl: 'app/terms/templates/tratamiento_de_datos.html',
                        controller: 'TratamientoDatosController',
                        controllerAs: 'tratamientodatos'
                    }
                }
            }
        )
        .state('public2.avisoprivacidad', {
                url: '/avisoprivacidad',
                cache: false,
                views: {
                    'container@public2': {
                        templateUrl: 'app/terms/templates/aviso_privacidad.html',
                        controller: 'AvisoPrivacidadController',
                        controllerAs: 'avisoprivacidad'
                    }
                }
            }
        )
        .state('private.home', {
                url: '/home',
                cache: false,
                params: {
                    page: null
                },
                views: {
                    'container@private': {
                        templateUrl: 'app/home/templates/home.html',
                        controller: 'HomeController',
                        controllerAs: 'home'
                    }
                }
            }
        )
        .state('private.productDetails', {
                url: '/productdetails/:id',
                cache: false,
                params: {
                    id: null,
                    page: null
                },
                views: {
                    'container@private': {
                        templateUrl: 'app/products/templates/details.html',
                        controller: 'ProductDetailsController',
                        controllerAs: 'productdetails'
                    }
                }
            }
        )
        .state('private.shoppingcar', {
                url: '/shoppingcar',
                cache: false,
                views: {
                    'container@private': {
                        templateUrl: 'app/shoppingcar/templates/shoppingcar.html',
                        controller: 'ShoppingCarController',
                        controllerAs: 'shoppingcar'
                    }
                }
            }
        )
        .state('private.orders', {
                url: '/orders',
                cache: false,
                views: {
                    'container@private': {
                        templateUrl: 'app/orders/templates/orders.html',
                        controller: 'OrdersController',
                        controllerAs: 'orders'
                    }
                }
            }
        )
        .state('private.orderResume', {
                url: '/orderview',
                cache: false,
                params: {
                    orderId: null
                },
                views: {
                    'container@private': {
                        templateUrl: 'app/orders/templates/orderview.html',
                        controller: 'OrderViewController',
                        controllerAs: 'orderview'
                    }
                }
            }
        )
        .state('private.profile', {
                url: '/profile',
                cache: false,
                views: {
                    'container@private': {
                        templateUrl: 'app/profile/templates/profile.html',
                        controller: 'ProfileController',
                        controllerAs: 'profile'
                    }
                }
            }
        )
        .state('private.terms', {
                url: '/terms',
                cache: false,
                views: {
                    'container@private': {
                        templateUrl: 'app/terms/templates/terms.html',
                        controller: 'TermsController',
                        controllerAs: 'terms'
                    }
                }
            }
        );

    /**
     * Skip if logged in
     */
    function skipIfLoggedIn($q, $location, AuthStorage)
    {
        var deferred = $q.defer();
        if (AuthStorage.isAuthenticated()) {
            $location.path('/home');
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    /**
     * Login required
     */
    function loginRequired($q, $location, AuthStorage)
    {
        var deferred = $q.defer();
        if (AuthStorage.isAuthenticated()) {
            deferred.resolve();
        } else {
            $location.path('/login');
        }
        return deferred.promise;
    }
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('Config', {
        ENV: {
            //'API_ENDPOINT': 'http://localhost/eterna-api/public',
            'API_ENDPOINT': 'https://empleadoseterna.com/eterna-api/public',
		    'PREFERRED_LANGUAGE': 'es',
		    'FALLBACK_LANGUAGE': 'es',
		    'API_GRANT_TYPE': 'password',
		    'API_CLIENT_ID': '3',
		    'API_CLIENT_SECRET': 'fFtWe0sgiHz22TFFFRmGxbbZCmJaeNbJddtzXHBb',
            'PRODUCT_MAX_AMOUNT': 5
            /*endinject*/
        },
        BUILD: {
            /*inject-build*/
            /*endinject*/
        }

    });

})();

(function() {
  'use strict';

  angular
    .module('eternaWeb2')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $translateProvider, $httpProvider, ngImageGalleryOptsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = false;

    /**
     * Translate
     */
    $translateProvider.useStaticFilesLoader({//@see http://angular-translate.github.io/docs/#/guide/12_asynchronous-loading
        files: [{
            prefix: 'app/main/assets/locales/',
            suffix: '.json'
        }]
    });
    $translateProvider.registerAvailableLanguageKeys(['en', 'es'], {
        'en': 'en', 'es': 'es'
    });
    $translateProvider.preferredLanguage('es');
    $translateProvider.fallbackLanguage('en');
    $translateProvider.determinePreferredLanguage();
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.forceAsyncReload(true);

    /**
     * NgImageGallery
     */
    ngImageGalleryOptsProvider.setOpts({
        thumbnails      :   true,
        thumbSize       :   80,
        inline          :   false,
        bubbles         :   true,
        bubbleSize      :   20,
        imgBubbles      :   false,
        bgClose         :   false,
        piracy          :   false,
        imgAnim         :   'fadeup',
    });
  }

})();

angular.module("eternaWeb2").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=lead><img src=assets/images/yeoman.png alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=main.classAnimation><button type=button class=\"btn btn-lg btn-success\" ng-click=main.showToastr()>Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=row><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=thumbnail><img class=pull-right ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=caption><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href={{awesomeThing.url}}>{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/auth/templates/auth-alert.html","<div class=alert-msg-center>{{login.alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=login.alerts.accept_btn ng-click=closeThisDialog() class=\"btn btn-custom btn-sm btn-inline-block\">{{login.alerts.accept_btn}}</button></div>");
$templateCache.put("app/auth/templates/disable.html","<p>Esta plataforma se encuentra cerrada para solicitudes de pedido, en este momento nos encontramos realizando el despacho; Recuerda que este espacio se habilita para los procesos de compra virtual del 1 al 10 de cada mes.</p>");
$templateCache.put("app/auth/templates/login.html","<form method=post id=loginFormId name=loginFormName ng-submit=login.doLogin(loginFormName) novalidate><h2 class=title-login>Bienvenido</h2><div class=\"list-group list-group-sm\"><div class=list-group-item><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-light rounded placeholder-center\" ng-model=login.credentials.username name=username placeholder=Usuario required type=text></div><div class=list-group-item><input class=\"form-control form-control-remove-chrome-autofill orange-border-light rounded placeholder-center\" ng-model=login.credentials.password name=password placeholder=Contraseña required type=password></div><div class=\"list-group-item text-center\"><a ui-sref=public.remember_password>¿Olvidó la contraseña?</a></div><div class=list-group-item><button type=submit class=\"btn btn-lg btn-custom btn-uppercase btn-block\" ng-disabled=login.showLoading><span ng-if=!login.showLoading>Entrar</span> <span ng-if=login.showLoading class=\"fas fa-spinner\"></span></button></div></div></form>");
$templateCache.put("app/auth/templates/remember-password-alert.html","<div class=alert-msg-center>{{rememberpass.alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=rememberpass.alerts.accept_btn ng-click=closeThisDialog() class=\"btn btn-custom btn-sm btn-inline-block\">{{rememberpass.alerts.accept_btn}}</button></div>");
$templateCache.put("app/auth/templates/remember_password.html","<form method=post id=rememberPassFormId name=rememberPassFormName ng-submit=rememberpass.sendEmail(rememberPassFormName) novalidate><h2 class=title-login>Recordar contraseña</h2><div class=\"list-group list-group-sm\"><div class=list-group-item><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=rememberpass.credentials.username name=username placeholder=E-mail required type=email></div><div class=\"list-group-item text-center\"><button ng-click=rememberpass.returnLogin() type=button class=\"btn btn-md btn-custom-light-gray btn-uppercase btn-inline-block\" ng-disabled=showLoading><span>Cancelar</span></button> <button type=submit class=\"btn btn-md btn-custom btn-uppercase btn-inline-block\" ng-disabled=showLoading><span>Envíar</span></button></div></div></form>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/home/templates/home.html","<div class=row><div class=\"col-xs-12 visible-xs visible-sm\"><form><div class=col-xs-12><h3 class=aside-title-xs>Filtrar</h3></div><div class=col-xs-12><div class=form-group><input type=text ng-model=home.paramsProducts.q class=\"form-control-sm search-home-input purple-border-bold\" name=searchText id=searchText placeholder=Buscar ng-enter=home.enterGetProducts()></div></div><div class=col-xs-12><div class=form-group><label>Categoría</label><select class=\"form-control purple-border-bold custom-select custom-select-purple\" name=category_group ng-model=home.categoryGroupSelected ng-change=home.updateCategoriesSelect()><option value=\"\">--Seleccione--</option><option value={{group.id}} ng-repeat=\"group in home.categoryGroupList\">{{group.name}}</option></select></div></div><div class=col-xs-12><div class=form-group><label>Sub categoría</label><select class=\"form-control purple-border-bold custom-select custom-select-purple\" name=category_group ng-model=home.categorySelected ng-change=home.sendCategorySelected()><option value=\"\">--Seleccione--</option><option value={{cat.id}} ng-repeat=\"cat in home.categoriesSelect\">{{cat.name}}</option></select></div></div></form></div><div class=\"col-lg-2 hidden-xs hidden-sm sidebar\"><h3 class=aside-title>Categorías</h3><!-- Search --><form class=\"navbar-form navbar-form-sm navbar-left shift\"><div class=form-group><div class=input-group><input type=text ng-model=home.paramsProducts.q class=\"form-control-sm search-home-input purple-border-bold\" name=searchText id=searchText placeholder=Buscar ng-enter=home.enterGetProducts()></div></div></form><div class=clearfix></div><div ng-if=\"!home.showLoadingGroup && home.categoryGroupList.length\" id=accordion_categories><div class=card ng-repeat=\"group in home.categoryGroupList\"><div class=card-header><a class=card-link data-toggle=collapse href=#group{{group.id}} ng-click=home.toggleCategory(group)><span ng-if=!group.expanded data-toggle=collapse href=#group{{group.id}} class=\"fas fa-angle-right\"></span> <span ng-if=group.expanded data-toggle=collapse href=#group{{group.id}} class=\"fas fa-angle-down\"></span> {{group.name}}</a></div><div id=group{{group.id}} class=collapse data-parent=#accordion><div class=card-body><ul class=list-group><li class=list-group-item ng-class=\"{\'active\': category.activeDom }\" ng-repeat=\"category in group.categories\"><a class=card-link ng-click=home.getProductsFromCat(category.id)>{{category.name}}</a></li></ul></div></div></div></div></div><div class=\"col-xs-12 col-lg-10 offset-lg-2 products-home\"><div class=col-xs-12><h3 class=\"section-title text-center\">Productos</h3><div class=col-xs-12><div class=img-home-web-banner><img src={{home.bannerWeb}} class=img-responsive alt=\"\"></div><div class=img-home-mobile-banner><img src={{home.bannerMobile}} class=img-responsive alt=\"\"></div></div><div class=\"texto-legal-promociones col-md-12\"><div class=\"col-md-8 col-md-offset-2 col-xs-12\">{{home.legalPromo}}</div></div><div class=\"full-width text-center\" ng-if=home.showLoadingProducts><loading displayasrow=false hasbackground=false block=false size=\"\'2x\'\"></loading></div><p class=text-center ng-if=\"!home.showLoadingProducts && !home.productList.length\">No se encontraron productos en el momento</p><ul ng-if=\"!home.showLoadingProducts && home.productList.length\" class=list-inline><li class=list-inline-item ng-repeat=\"product in home.productList\"><product-item product=product reload-parent=home.updateProductItem(productItem) page=home.productsPaging.current_page></product-item></li></ul><div class=\"full-width text-center\"><paging page=home.productsPaging.current_page page-size=home.productsPaging.per_page total=home.productsPaging.total show-prev-next=true show-first-last=true paging-action=\"home.goPage(\'pageClicked\', page)\" hide-if-empty=true ul-class=pagination></paging></div></div></div></div>");
$templateCache.put("app/orders/templates/orders.html","<div class=col-xs-12><h3 class=\"section-title text-center\">Mi historial de pedidos</h3><div class=\"full-width text-center\" ng-if=orders.showLoading><loading displayasrow=false hasbackground=false block=false size=\"\'2x\'\"></loading></div><div ng-if=!orders.showLoading class=full-width><div class=row><div class=col-xs-12><div class=\"col-xs-12 col-sm-4 offset-sm-8\"><div class=form-group><label>Estado:</label><select class=\"form-control purple-border-bold custom-select custom-select-purple\" name=order_status ng-model=orders.orderStatusSelected ng-change=orders.updateOrdersStatusSelect()><option value={{status_item.id}} ng-repeat=\"status_item in orders.orderStatusList\">{{status_item.name}}</option></select></div></div></div></div></div><!--<loading ng-if=\"orders.showLoading\" [displayAsRow]=\"true\" [hasBackground]=\"false\" [block]=\"true\" [size]=\"\'2x\'\"></loading>--><div class=col-xs-12 ng-if=\"!orders.showLoading && !orders.orderList.length\"><p>No hay ordenes de compra generadas</p></div><div class=\"full-width visible-xs\" ng-if=\"!orders.showLoading && orders.orderList.length\"><div class=item-order-no-table ng-repeat=\"order in orders.orderList\"><div class=row><div class=col-xs-12><h6 class=item-data-title>No. Orden</h6><p class=\"item-data-value big\">{{order.order_ref_id}}</p><h6 class=item-data-title>Resumen de compra</h6><p class=\"item-data-value small\"><strong>Fecha:</strong> {{order.created_at}}<br><strong>Cantidad de productos:</strong> {{order.products.length}}</p><p class=\"item-data-value big\"><strong>Total:</strong> ${{order.total_price}}</p><h6 class=item-data-title>Estado</h6><p class=\"item-data-value small\">{{order.statusText}}</p><button ng-class=\"{\'btn-custom-white\': !order.expanded, \'btn-custom-light-gray\': order.expanded}\" ng-click=orders.toggleShowDetails(order) class=\"btn btn-sm\"><i ng-if=!order.expanded class=\"fas fa-angle-down\"></i> <i ng-if=order.expanded class=\"fas fa-angle-up\"></i></button></div></div><div class=row><div class=col-xs-12 ng-if=order.expanded><order-details order=order></order-details></div></div></div></div><div class=\"col-xs-12 hidden-xs\" ng-if=\"!orders.showLoading && orders.orderList.length\"><table class=\"table table-shopping-car orders-table\"><thead><tr><th scope=col class=text-center>No. Orden</th><th scope=col class=text-center>Resumen de compra</th><th scope=col class=text-center>Estado</th><th scope=col class=text-center></th></tr></thead><tbody><tr><td colspan=4></td></tr><tr ng-class=\"{\'active\': order.expanded }\" class=order-row ng-repeat-start=\"order in orders.orderList\"><td class=text-center>{{order.order_ref_id}}</td><td class=text-left><strong>Cantidad de productos:</strong> {{order.products.length}}<br><strong>Total:</strong> ${{order.total_price}}<br><strong>Fecha:</strong> {{order.created_at}}</td><td class=text-center>{{order.statusText}}</td><td class=text-center><button ng-class=\"{\'btn-custom-white\': !order.expanded, \'btn-custom-light-gray\': order.expanded}\" ng-click=orders.toggleShowDetails(order) class=\"btn btn-sm\"><i ng-if=!order.expanded class=\"fas fa-angle-down\"></i> <i ng-if=order.expanded class=\"fas fa-angle-up\"></i></button></td></tr><tr class=order-details-row><td colspan=4 ng-if=order.expanded><order-details order=order></order-details></td></tr><tr class=order-blank-row ng-repeat-end><td colspan=4></td></tr></tbody></table></div><div class=\"full-width text-center\" ng-if=\"!orders.showLoading && orders.orderList.length\"><paging page=orders.ordersPaging.current_page page-size=orders.ordersPaging.per_page total=orders.ordersPaging.total show-prev-next=true show-first-last=true paging-action=\"orders.goPage(\'pageClicked\', page)\" hide-if-empty=true ul-class=pagination></paging></div><div class=clearfix></div><div class=bottom-space></div></div>");
$templateCache.put("app/orders/templates/orderview.html","<p ng-if=\"!orderview.showLoading && !orderview.orderInfo\">No se encontro la información buscada</p><div class=\"full-width text-center\" ng-if=orderview.showLoading><loading displayasrow=false hasbackground=false block=false size=\"\'2x\'\"></loading></div><div class=full-width ng-if=\"!orderview.showLoading && orderview.orderInfo\" id=printElement><div class=container><h3 ng-if=orderview.isBuy class=section-title>Gracias por tu pedido, {{orderview.orderInfo.user.full_name}}</h3></div><div class=\"row bg-light-gray title-container\"><div class=container><h5 class=section-subtitle>Detalles de envío</h5></div></div><div class=container><p><strong>Número de orden:</strong> <span class=purple-color>{{orderview.orderInfo.order_ref_id}}</span></p><p><strong>Envíado a:</strong> <span>{{orderview.orderInfo.user.full_name}}</span></p><p><strong>Fecha de envío:</strong> <span>{{orderview.orderInfo.created_at}}</span></p><p><strong>Destino:</strong> <span>{{orderview.orderInfo.user.address}}</span></p><p><strong>Número de contacto:</strong> <span>--</span></p></div><div class=\"row bg-light-gray title-container\"><div class=container><h5 class=section-subtitle>Detalle de tu orden de pedido</h5></div></div><div class=container><p><strong>Contenido</strong></p><div class=\"col col-sm-8 light-gray-border-bottom-light\"><table width=100% class=table-no-style><tbody><tr ng-repeat=\"product in orderview.orderInfo.products\"><td width=70%>{{product.info.title}} <span ng-repeat=\"attribRef in product.infoReference.main_attributes\">{{attribRef.name}}: {{attribRef.valores[0].value_attrib}} </span><br>Ref: {{product.infoReference.sku}}</td><td>${{product.total_price}}</td></tr></tbody></table></div><div class=clearfix></div><div class=\"col col-sm-4 offset-sm-4\"><table width=100% class=table-no-style><tbody><tr><td class=\"bg-light-gray light-gray-border-bottom-light\" width=60%><strong>Subtotal</strong></td><td class=\"bg-light-gray light-gray-border-bottom-light\">${{orderview.orderInfo.total_price}}</td></tr><tr><td class=\"bg-light-gray light-gray-border-bottom-light\" width=60%><strong>Costo de envío</strong></td><td class=\"bg-light-gray light-gray-border-bottom-light\">$0</td></tr><tr><td class=\"bg-light-gray light-gray-border-bottom-light\" width=60%><strong>Total</strong></td><td class=\"bg-light-gray light-gray-border-bottom-light\">${{orderview.orderInfo.total_price}}</td></tr></tbody></table></div></div><div class=container><p>Este detalle corresponde al resumen del pedido que has solicitado el cual está sujeto a disponibilidad de inventario, por tanto, el valor a descontar será el evidenciado en la factura de venta que te llegará previamente al correo electrónico.</p></div></div><div class=full-width ng-if=\"!orderview.showLoading && orderview.orderInfo\"><div class=container><div class=\"col col-sm-4 offset-sm-4\"><table width=100% class=table-no-style><tbody><tr><td class=text-center><button id=overview-print-btn style=\"margin-top: 20px\" ng-print print-element-id=printElement class=\"btn btn-md btn-custom btn-inline-block\">Imprimir / Guardar como PDF</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/products/templates/details.html","<p ng-if=\"!productdetails.showLoading && !productdetails.productInfo\">No se encontro la información buscada</p><div class=\"full-width text-center\" ng-if=productdetails.showLoading><loading displayasrow=false hasbackground=false block=false size=\"\'2x\'\"></loading></div><div id=product-details-section class=full-width ng-if=\"!productdetails.showLoading && productdetails.productInfo\"><div class=content-return><button class=\"btn btn-sm btn-inline-block btn-custom-orange\" ng-click=productdetails.returnProductPage()>Volver</button></div><div class=container><h3 class=\"section-title text-center\">{{productdetails.productInfo.title}}</h3><div class=row><div class=\"col-xs-12 col-sm-5\"><img ng-if=productdetails.productInfo.url ng-src={{productdetails.productInfo.url}} class=img-fluid> <img ng-if=!productdetails.productInfo.url src=assets/images/without-product-pic.png class=img-fluid></div><div class=\"col-xs-12 col-sm-7 content-product-details-data\"><p ng-bind-html=productdetails.productInfo.description></p><div class=content-product-details-bottom><p><strong>{{productdetails.productInfo.price | currency:\"$\":0}}</strong></p><div ng-if=productdetails.productInfo.attributes.length class=full-width><div class=row><div class=\"col-3 col-sm-3\" ng-repeat=\"attribute in productdetails.productInfo.attributes\"><label>{{attribute.name}}</label><select class=\"form-control purple-border-bold custom-select custom-select-purple\" name=product_attr_{{attribute.id}} ng-model=productdetails.attributesChoosed[$index].valor><option value={{attributeValues.id}} ng-repeat=\"attributeValues in attribute.valores\">{{attributeValues.value_attrib}}</option></select></div></div></div><div class=\"clearfix attributes-row\"></div><div class=full-width><button type=button class=\"btn btn-sm btn-inline-block btn-custom\" ng-disabled=productdetails.isAdding ng-click=productdetails.addShoppingCart()><span ng-if=!productdetails.isAdding>Añadir</span> <span ng-if=productdetails.isAdding class=\"fas fa-spinner\"></span></button></div></div></div></div></div></div>");
$templateCache.put("app/products/templates/product-alert.html","<div class=alert-msg-center>{{alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=alerts.accept_btn ng-click=closeThisDialog() class=\"btn btn-custom btn-sm btn-inline-block\">{{alerts.accept_btn}}</button></div>");
$templateCache.put("app/products/templates/product-details-alert.html","<div class=alert-msg-center>{{productdetails.alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=productdetails.alerts.accept_btn ng-click=closeThisDialog() class=\"btn btn-custom btn-sm btn-inline-block\">{{productdetails.alerts.accept_btn}}</button></div>");
$templateCache.put("app/profile/templates/editar-data.html","<!--- BUTTON --><div class=row><div class=col-xs-12><button style=\"margin-left: 0px\" ng-click=profile.toggleEdit() type=button class=\"btn btn-sm btn-custom btn-inline-block\">Modificar</button></div></div><!-- FORM TO EDIT --><div class=\"col-xs-12 col-md-5\" ng-if=profile.editData><h4 class=\"profile-title orange-color text-uppercase\">Datos de Envío</h4><form method=post id=userFormId name=userFormName ng-submit=profile.updateDataDelivery(userFormName) novalidate><div class=form-group><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.profileDataCopy.telephone name=telephone placeholder=Teléfono required type=text></div><div class=form-group><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.profileDataCopy.cellphone name=cellphone placeholder=Celular required type=text></div><div class=form-group><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.profileDataCopy.email name=email placeholder=E-mail required type=email></div><div class=form-group><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.profileDataCopy.delivery_address name=delivery_address placeholder=\"Dirección de envío\" required type=text></div><div class=form-group><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.profileDataCopy.delivery_city name=delivery_city placeholder=Ciudad required type=text></div><div class=form-group><input autofocus class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.profileDataCopy.delivery_country name=delivery_country placeholder=País required type=text></div><div class=form-group><button ng-click=profile.toggleEdit() type=button class=\"btn btn-sm btn-custom-light-gray btn-uppercase btn-inline-block\" ng-disabled=isSaving>Cancelar</button> <button type=submit class=\"btn btn-sm btn-custom btn-uppercase btn-inline-block\" ng-disabled=isSaving><span>Guardar</span></button></div></form></div>");
$templateCache.put("app/profile/templates/profile-alert.html","<div class=alert-msg-center>{{profile.alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=profile.alerts.accept_btn ng-click=closeThisDialog() class=\"btn btn-custom btn-sm btn-inline-block\">{{profile.alerts.accept_btn}}</button></div>");
$templateCache.put("app/profile/templates/profile.html","<div class=\"col-xs-12 profile-page\"><h3 class=\"section-title text-center\">Mi Cuenta</h3><div class=\"row align-items-center\"><div class=\"col-xs-12 col-md-7 profile-first-section\"><div class=\"row align-items-center\"><div class=\"col-12 col-sm-4 text-center profile-pic-section\"><div class=profile-pic><img src={{profile.profileData.url}} class=img-fluid></div><a ng-if=!profile.fileSaving ngf-select=\"profile.uploadImgProfile($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg\'\" class=\"btn btn-sm btn-custom-light-gray btn-inline-block\">Cambiar foto</a></div><div class=\"col-12 col-sm-8\"><h4 class=\"profile-title orange-color text-uppercase\">Datos Empresariales</h4><h3 class=\"profile-highlight-text text-uppercase purple-color\">{{profile.profileData.full_name}}</h3><p class=item-data-profile><strong>{{(profile.profileData.position) ? profile.profileData.position : \'Sin cargo\'}}</strong></p><p class=item-data-profile>{{(profile.profileData.area) ? profile.profileData.area : \'Sin departamento\'}}</p><p class=item-data-profile>{{(profile.profileData.address) ? profile.profileData.address : \' \'}}</p><p class=item-data-profile>{{(profile.profileData.city) ? profile.profileData.city+\',\' : \'\'}} {{(profile.profileData.country) ? profile.profileData.country : \'\'}}</p><form ng-if=profile.editPassword method=post id=passwordFormId name=passwordFormName ng-submit=profile.updatePasswordData(passwordFormName) novalidate><div class=form-group><input class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.passwordData.current name=current placeholder=\"Contraseña actual\" required type=password></div><div class=form-group><input class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.passwordData.newpass name=newpass placeholder=\"Nueva contraseña\" required type=password></div><div class=form-group><input class=\"form-control form-control-remove-chrome-autofill orange-border-bold rounded placeholder-center\" ng-model=profile.passwordData.confirmpass name=confirmpass placeholder=\"Confirme contraseña\" required type=password></div><div class=form-group><button ng-click=profile.toggleEditPassword() type=button class=\"btn btn-sm btn-custom-light-gray btn-uppercase btn-inline-block\" ng-disabled=isSaving>Cancelar</button> <button type=submit class=\"btn btn-sm btn-custom btn-uppercase btn-inline-block\" ng-disabled=isSaving><span>Cambiar contraseña</span></button></div></form><button ng-if=!profile.editPassword type=button ng-click=profile.toggleEditPassword() class=\"btn btn-sm btn-custom-light-gray btn-inline-block\">Cambiar contraseña</button></div></div></div><div class=\"col-xs-12 col-md-5\" ng-if=!profile.editData><h4 class=\"profile-title orange-color text-uppercase\">Datos de Envío</h4><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>Teléfono:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.telephone) ? profile.profileData.telephone : \'-\'}}</div></div><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>Celular:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.cellphone) ? profile.profileData.cellphone : \'-\'}}</div></div><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>E-mail:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.email) ? profile.profileData.email : \'-\'}}</div></div><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>Dirección:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.delivery_address) ? profile.profileData.delivery_address : \'-\'}}</div></div><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>Ciudad:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.delivery_city) ? profile.profileData.delivery_city : \'-\'}}</div></div><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>País:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.delivery_country) ? profile.profileData.delivery_country : \'-\'}}</div></div><div class=row><div class=\"col-xs-4 item-data-profile\"><span class=purple-color><strong>Cupo Máximo:</strong></span></div><div class=\"col-xs-8 item-data-profile\">{{(profile.profileData.current_credit_amount) ? \'$\'+profile.profileData.current_credit_amount : \'-\'}}</div></div><!-- here is the button--></div><!--here is the form to edit--></div><div class=clearfix></div><div class=bottom-space></div></div>");
$templateCache.put("app/shoppingcar/templates/confirm-alert.html","<div class=alert-msg-center>{{shoppingcar.alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=shoppingcar.alerts.cancel_btn ng-click=closeThisDialog() class=\"btn btn-custom-light-gray btn-sm btn-inline-block\">{{shoppingcar.alerts.cancel_btn}}</button> <button ng-if=shoppingcar.alerts.accept_btn ng-click=shoppingcar.processShoppingCar() class=\"btn btn-custom btn-sm btn-inline-block\">{{shoppingcar.alerts.accept_btn}}</button></div>");
$templateCache.put("app/shoppingcar/templates/error-alert.html","<div class=alert-msg-center>{{shoppingcar.alerts.msg}}</div><div class=\"alert-footer text-center\"><button ng-if=shoppingcar.alerts.accept_btn ng-click=closeThisDialog() class=\"btn btn-custom btn-sm btn-inline-block\">{{shoppingcar.alerts.accept_btn}}</button></div>");
$templateCache.put("app/shoppingcar/templates/shoppingcar.html","<div class=col-xs-12><div class=col-xs-12><h3 class=\"section-title text-center\">Carrito de Compras</h3><div class=\"full-width text-center\" ng-if=shoppingcar.showLoading><loading displayasrow=false hasbackground=false block=false size=\"\'2x\'\"></loading></div></div><div class=clearfix></div><!--<loading ng-if=\"showLoading\" [displayAsRow]=\"true\" [hasBackground]=\"false\" [block]=\"true\" [size]=\"\'2x\'\"></loading>--><p ng-if=\"!shoppingcar.showLoading && !shoppingcar.shoppingCarList.length\">Tu carrito esta vacio</p><div class=\"full-width visible-xs\" ng-if=\"!shoppingcar.showLoading && shoppingcar.shoppingCarList.length\"><div class=item-shopping-car-no-table ng-repeat=\"item in shoppingcar.shoppingCarList\"><div class=row><div class=col-xs-6><img ng-if=item.product.url ng-src={{item.product.url}} class=img-fluid> <img ng-if=!item.product.url src=assets/images/without-product-pic.png class=img-fluid></div><div class=col-xs-6><h6>{{item.product.title}} <span ng-repeat=\"attribRef in item.productReference.main_attributes\">{{attribRef.name}}: {{attribRef.valores[0].value_attrib}}</span></h6><div class=row><div class=\"col-xs-4 price-unit\">${{item.productReference.price | currency:\"$\":0}}</div><div class=\"col-xs-8 amount-field\"><button type=button class=\"btn btn-sm btn-custom-white btn-inline-block\" ng-click=shoppingcar.discountAmount(item)>-</button> <input type=number name=amountField id=amount_{{item.id}} ng-model=item.amount class=\"form-control amountField text-center\" ng-change=shoppingcar.onChangeItemAmount(item)> <button type=button class=\"btn btn-sm btn-custom-white btn-inline-block\" ng-click=shoppingcar.incrementAmount(item)>+</button></div></div></div></div><div class=row><div class=\"col-xs-6 offset-6 text-left total-price\">Total: ${{shoppingcar.calcTotalItem(item.productReference.price, item.amount)}}</div></div></div></div><div ng-if=\"!shoppingcar.showLoading && shoppingcar.shoppingCarList.length\" class=\"col-xs-12 hidden-xs\"><table class=\"table table-shopping-car common-table\"><thead><tr><th width=100 scope=col class=text-center></th><th scope=col class=text-center>Producto</th><th scope=col class=text-center>Precio</th><th scope=col class=text-center>Cantidad</th><th width=15% scope=col class=text-center>Total</th><th scope=col class=text-center></th></tr></thead><tbody><tr ng-repeat=\"item in shoppingcar.shoppingCarList\"><td width=10% class=text-center><img ng-if=item.product.url ng-src={{item.product.url}} class=img-fluid> <img ng-if=!item.product.url src=assets/images/without-product-pic.png class=img-fluid></td><td class=text-center>{{item.product.title}} <span ng-repeat=\"attribRef in item.productReference.main_attributes\">{{attribRef.name}}: {{attribRef.valores[0].value_attrib}}</span></td><td class=text-center>{{item.productReference.price | currency}}</td><td class=text-center><form class=\"form-inline justify-content-center\"><button type=button class=\"btn btn-sm btn-custom-white btn-inline-block\" ng-click=shoppingcar.discountAmount(item)>-</button> <input type=number name=amountField id=amount_{{item.id}} ng-model=item.amount class=\"form-control amountField text-center\" ng-change=shoppingcar.onChangeItemAmount(item)> <button type=button class=\"btn btn-sm btn-custom-white btn-inline-block\" ng-click=shoppingcar.incrementAmount(item)>+</button></form></td><td class=text-center>{{shoppingcar.calcTotalItem(item.productReference.price, item.amount) | currency}}</td><td><button ng-disabled=item.loadingDelete ng-click=shoppingcar.deleteItemFromShoppingCar(item) type=button class=\"btn btn-sm btn-without-border\"><i ng-if=!item.loadingDelete class=\"fas fa-times\"></i> <i ng-if=item.loadingDelete class=\"fas fa-spinner\"></i></button></td></tr></tbody></table></div><div class=clearfix></div><div ng-if=\"!shoppingcar.showLoading && shoppingcar.shoppingCarList.length\" class=col-xs-12><div class=\"col-12 col-sm-6 shopping-car-empty-btn-container\"><button ng-disabled=shoppingcar.showLoadingDelete ng-click=shoppingcar.deleteAllShoppingCar() type=button class=\"btn btn-sm btn-custom-light-gray btn-inline-block\">Vaciar carrito</button></div><div class=\"col-12 col-sm-6\"><table class=\"table table-shopping-car-summary common-table\" align=right><thead><tr><th colspan=2 scope=col class=text-center>Resumen de la compra</th></tr></thead><tbody><tr><td width=50%>Subtotal</td><td width=50%>{{shoppingcar.calcTotalShopping() | currency}}</td></tr><tr><td width=50%>Costo de envío</td><td width=50%>$0</td></tr><tr><td width=50% class=hightlight-text><strong>Total a deducir</strong></td><td width=50% class=hightlight-text><strong>{{shoppingcar.calcTotalShopping() | currency}}</strong></td></tr><tr><td colspan=2 class=\"text-right no-style\"><button ng-click=shoppingcar.goHome() type=button class=\"btn btn-sm btn-custom-light-gray btn-inline-block\">Seguir Comprando</button> <button ng-click=shoppingcar.showConfirmProcessAlert() type=button class=\"btn btn-sm btn-custom btn-inline-block\">Finalizar Compra</button></td></tr><!--<tr>\n			  		<td colspan=\"2\" class=\"text-left no-style small-text\">\n			  			<span>*Ten en cuenta que cuando oprimas el botón de finalizar compra, el valor total será descontado de tu nómina.</span>\n			  		</td>\n			  	</tr>--></tbody></table></div></div><div class=clearfix></div><div class=bottom-space></div></div>");
$templateCache.put("app/terms/templates/aviso_privacidad.html","<div class=\"col-xs-12 profile-page\"><h3 class=\"section-title text-center\">AVISO DE PRIVACIDAD</h3><h4 class=\"section-subtitle text-center\">SITIO WEB</h4><div class=align-items-center><div class=col-xs-12><p>ETERNA S.A. (en adelante, \"ETERNA\"), con domicilio en la carrera 66 No. 13-43, Barrio las Granjas de la ciudad de Bogotá, en cumplimiento a lo establecido en la Ley 1581 de 2012, el Decreto Reglamentario 1377 de 2013 y las demás normas que los modifiquen, adicionen y/o complementen, tiene entre sus objetivos proteger el tratamiento de los Datos Personales proporcionados por sus Usuarios por lo que estos serán tratados mediante el uso y mantenimiento de medidas de seguridad técnicas, físicas y administrativas adecuadas a fin de impedir que terceros no autorizados accedan a los mismos.</p><p>Al utilizar Sitio Web eterna.com.co (el “Sitio Web”) usted autoriza que los Datos Personales que nos suministre puedan llegar a ser utilizados para trámites relacionados con los servicios contratados o para futuras negociaciones según sean aplicables, para remitir información de nuestros productos, evaluaciones de calidad, remitir información sobre eventos y/o promociones de tipo comercial y para fines administrativos, desarrollar el objeto social de ETERNA, brindar la mejor experiencia personalizada en el uso de los servicios que ETERNA proporciona, procesar y administrar las transacciones solicitadas por el Usuario del Sitio Web de ETERNA las cuales Incluyen: presentación de quejas y/o reclamos; sugerencias; solicitud de información; realización de fichas técnicas e interés en trabajar con ETERNA Esto a través de correo físico, electrónico, celular o dispositivo móvil, vía mensajes de texto, o a través de cualquier medio análogo y/o digital de comunicación, conocido o por conocer, de acuerdo con los términos y condiciones de las Políticas de Privacidad abajo señaladas.</p><p>Si usted lo desea, podrá ejercer sus derechos de conocer, actualizar, rectificar y suprimir sus datos personales enviando su solicitud al correo electrónico info@eterna.com.co, o de forma escrita dirigida a la Av. Calle 26 # 57 - 83 Torre 7 - Piso 4 Bogotá, Colombia. Para conocer la Política de Privacidad bajo la cual serán tratados los datos personales suministrados por el Usuario, favor de ingresar al sitio web <a href=https://eterna.com.co/wp-content/themes/eterna/pdf/politica_de_tratamiento_de_datos_eterna.pdf target=_blank>https://eterna.com.co/wp-content/themes/eterna/pdf/politica_de_tratamiento_de_datos_eterna.pdf</a></p><p>Fecha de última actualización: abril de 2018</p><p>Acepto el tratamiento de la información en los términos aquí establecidos.</p></div></div><div class=clearfix></div><div class=bottom-space></div></div>");
$templateCache.put("app/terms/templates/terms.html","<div class=\"col-xs-12 profile-page\"><h3 class=\"section-title text-center\">Términos y Condiciones</h3><div class=align-items-center><div class=col-xs-12><ul id=tyc_list><li>Solo se permite la compra de un máximo de cinco (5) productos por cada referencia.</li><li>La compras virtuales serán descontadas por nomina en las dos quincenas del mes siguiente.</li><li>Cada colaborador cuenta con un cupo de compra mínimo de $40.000 pesos y máximo del 5% de su salario.</li><li>Antes de realizar los pedidos, es importante validar que la información esta correcta. Si se debe hacer algún cambio o actualización de datos se debe realizar directamente con el área de Gestión Humana.</li><li>La plataforma estará habilitada para la solicitud de pedidos, solo los primeros 10 días del mes; posterior a esto se realiza el alistamiento, facturación y la entrega será a partir de la última semana del mes.</li><li>La solicitud de pedido está sujeta a disponibilidad de inventario, por tanto, el valor a descontar será el evidenciado en la factura de venta electrónica que se enviará a su correo electrónico.</li><li>El lugar de entrega de los pedidos corresponde a la dirección que aparece registrada en el perfil. Para las personas que están trabajando desde casa el pedido les llegara a su respectiva vivienda, para los demás colaboradores su pedido será entregado en la sede en la que se encuentra su puesto de trabajo. (Cra. 66, CEDI y Ladecol)</li><li><strong>Ruteo Nacional:</strong> La Dirección de entrega corresponde a la dirección registrada con el área de Gestión Humana.<br><br><p><strong>Costa:</strong> Barranquilla, Cartagena, Montería, Sincelejo, Santa Marta.<br><strong>Antioquia:</strong> Medellín, Barbosa, Envigado, Itagüí.<br><strong>Occidente:</strong> Cali, Palmira, Pasto, Popayán, Tuluá.<br><strong>Oriente:</strong> Bucaramanga, Barrancabermeja, Cúcuta, Duitama, Sogamoso, Valledupar, Zipaquirá.<br><strong>Eje Cafetero:</strong> Armenia Pereira, Manizales.<br><strong>Centro Sur:</strong> Neiva, Florencia, Ibagué, Girardot.<br><strong>Llanos:</strong> Villavicencio, Yopal.</p></li></ul><form><div class=\"form-group text-center\"><input ng-disable=terms.agree_checkbox_disable ng-model=terms.agree_checkbox ng-true-value=1 ng-false-value=0 ng-change=terms.updateCheckbox() type=checkbox name=agree_terms id=agree_terms checked><label for=agree_terms><span><div class=refill></div></span>Acepto términos y condiciones</label></div><div class=\"form-group text-center\"><a class=\"btn btn-md btn-custom\" ui-sref=private.home>Enviar</a></div></form></div></div><div class=clearfix></div><div class=bottom-space></div></div>");
$templateCache.put("app/terms/templates/tratamiento_de_datos.html","<div class=\"col-xs-12 profile-page\"><h3 class=\"section-title text-center\">POLÍTICAS DE PRIVACIDAD Y TRATAIENTO DE DATOS PERSONALES</h3><h4 class=\"section-subtitle text-center\">SITIO WEB<br>ETERNA S.A.</h4><div class=align-items-center><div class=col-xs-12><p>En cumplimiento de la Ley 1581 de 2012 y el Decreto 1377 de 2013 y demás normas que reglamenten, modifiquen, complementen o adicionen, ETERNA S.A., (“ETERNA”/ la “Empresa”/ la “Compañía) pone a disposición del público en general la presente política de privacidad y tratamiento de datos personales desarrollada por la Empresa (en adelante la “Política”). Este mismo documento será puesto en conocimiento de los Encargados del Tratamiento y/o funcionarios de ETERNA para que den cabal cumplimiento a la misma.</p><p>La presente Política tiene como objeto establecer los lineamientos conforme a los cuales ETERNA realizará el tratamiento de Datos Personales contenidos en sus bases de datos obtenidas a través del Sitio Web, buscando siempre prevenir el uso y manejo indebidos de los mismos y garantizando medidas de seguridad y confidencialidad adecuadas. En la presente Política se establecen los derechos y responsabilidades de los Titulares de la información, así como los deberes y compromisos de ETERNA en la utilización de dicha información.</p><p>Por lo anterior, los Titulares deberán consultar esta Política o el correspondiente Aviso de Privacidad, cuando corresponda de manera previa a la entrega de información personal. Lo establecido en el presente documento será de aplicación al tratamiento de los datos personales suministrados a través del sitio web <a href=http://www.eterna.com.co target=_blank>www.eterna.com.co (el “Sitio Web”)</a>, razón por la cual se recomienda estar al tanto de los mismos antes de utilizar el Sitio Web; de no estar de acuerdo con la presente Política, los Titulares deberán abstenerse de utilizar el Sitio Web o de proporcionar sus datos a ETERNA.</p><div class=panel-group id=accordion_tratamiento_datos><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseOne><h4 class=section-subtitle>Responsables del Tratamiento de la Información</h4></a></h4></div><div id=collapseOne class=\"panel-collapse collapse in\"><div class=panel-body><p>Para todos los efectos ETERNA S.A. es la persona jurídica, de orden privado, Responsable del Tratamiento de la información. Para conocimiento del público, sus datos son los siguientes:</p><table border=0 width=80%><tbody><tr><td>RAZÓN SOCIAL</td><td>ETERNA S.A.</td></tr><tr><td>DOMICILIO</td><td>Bogotá D.C.</td></tr><tr><td>DIRECCIÓN</td><td>Carrera 66 No. 13-43, Barrio las Granjas</td></tr><tr><td>CORREO ELECTRÓNICO</td><td><a href=mailto:info@eterna.com.co>info@eterna.com.co</a></td></tr><tr><td>TELÉFONO</td><td>(57) 570 27 27 – 260 11 00</td></tr></tbody></table></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseTwo><h4 class=section-subtitle>Alcance</h4></a></h4></div><div id=collapseTwo class=\"panel-collapse collapse\"><div class=panel-body><p>La presente Política será aplicable al tratamiento de datos de Usuarios del Sitio Web, cuyos datos personales hayan sido recolectados por ETERNA a través del Sitio Web de ETERNA.</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseThree><h4 class=section-subtitle>Glosario</h4></a></h4></div><div id=collapseThree class=\"panel-collapse collapse\"><div class=panel-body><ul id=tyc_list><li>Autorización: Consentimiento previo, expreso e informado del Titular para llevar a cabo el tratamiento de datos personales.</li><li>Aviso de Privacidad: Se refiere al texto que se pondrá a disposición de los Titulares cuando no sea posible revelar esta Política de Privacidad.</li><li>Base de Datos: Conjunto organizado de datos personales que sea objeto de Tratamiento por parte de ETERNA o de un tercero encargado por ésta.</li><li>Encargado del Tratamiento: Persona natural o jurídica, pública o privada, que por sí misma o en asocio con otros, realice el Tratamiento de datos personales por cuenta de ETERNA.</li><li>Información/Datos Personales: Se refiere a cualquier información que sea tratada por ETERNA o por un tercero que éste designe y que identifica a una persona, o que puede razonablemente ser utilizada para identificar una persona, ya sea directa o indirectamente, sola o combinada con otros datos. Dentro de esta definición se incluye, entre otros, los siguientes tipos de información:<ol type=a><li>Datos de identificación</li><li>Datos de Contacto</li><li>Demás datos que generalmente se utilizan para identificar a las personas.</li></ol></li><li>Responsable del Tratamiento: Será ETERNA, al ser la entidad que decide sobre la base de datos y/o el Tratamiento de los Datos Personales.</li><li>SIC: se refiere a la Superintendencia de Industria y Comercio.</li><li>Sitio Web de ETERNA: será <a href=https://www.eterna.com.co target=_blank>www.eterna.com.co </a></li><li>Tercero: La persona física o moral, nacional o extranjera distinta del Titular o de ETERNA.</li><li>Titular: Persona natural cuyos datos personales sean objeto de Tratamiento.</li><li>Transferencia: Actividad que tiene lugar cuando el Responsable y/o Encargado del Tratamiento de datos personales, envía información o datos personales a un tercero que actuará como Responsable de los datos y que podrá estar dentro o fuera del país.</li><li>Transmisión: Tratamiento de datos personales que implica la comunicación de los mismos dentro o fuera del territorio de la República de Colombia, teniendo por objeto que se realice el Tratamiento por parte de un Encargado por cuenta del Responsable.</li><li>Tratamiento: Cualquier operación o conjunto de operaciones sobre datos personales, tales como la recolección, almacenamiento, uso, circulación o supresión.</li><li>Usuario: Cualquier persona natural que acceda al Sitio Web de ETERNA y se registre como usuario del mismo.</li></ul></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseFour><h4 class=section-subtitle>Tratamiento al cual serán sometidos los datos personales y finalidades</h4></a></h4></div><div id=collapseFour class=\"panel-collapse collapse\"><div class=panel-body><p>La información y Datos Personales suministrados a ETERNA podrán ser procesados, recolectados, almacenados, usados, suprimidos, compartidos, actualizados, transmitidos, para trámites relacionados con los servicios contratados o para futuras negociaciones según sean aplicables, principalmente para hacer posible la prestación de sus servicios y/o la venta de sus productos, y además de uso para fines administrativos, comerciales, de publicidad y contacto frente a los Titulares de los mismos, desarrollar el objeto social de ETERNA, brindar la mejor experiencia personalizada en el uso de los servicios que ETERNA proporciona, procesar y administrar las transacciones solicitadas por el Usuario del Sitio Web de ETERNA las cuales Incluyen: presentación de quejas y/o reclamos; sugerencias; solicitud de información; realización de fichas técnicas; interés en trabajar con ETERNA; Enviar por sí mismo o a través de terceros información/noticias de su interés, ya sean propios o bien de nuestros anunciantes y publicidad de terceros con quién ETERNA tenga celebrados convenios.</p><p>Las redes sociales (tales como Facebook y Twitter, entre otras) que constituyen una plataforma de comunicación y de interconexión entre plataformas digitales de los distintos usuarios, son ajenas a ETERNA y, por lo tanto, no se encuentran bajo su responsabilidad. La información que las personas proporcionen dentro de redes sociales en las que ETERNA participa como usuario, no constituye ni forma parte de los Datos Personales sujetos a la protección de esta Política, siendo responsabilidad de la empresa prestadora de esa plataforma y de quien realiza la publicación de la información.</p><h4 class=section-subtitle>Datos personales objeto de tratamiento</h4><p>A efectos de realizar de manera adecuada sus actividades, y de ejecutar su objeto social ETERNA recolectará Datos Personales de los Titulares que serán tratados con las finalidades expresamente informadas, o según se dispone en esta Política. ETERNA obtendrá la respectiva autorización e informará a los Titulares sobre los datos que en su momento se colecten para realizar el tratamiento. En este sentido, los Datos Personales se obtendrán a través de los diferentes canales o formatos que son diligenciados en el Sitio Web.</p><p>Dentro de los principales Datos Personales que se podrán recolectar se encuentran los siguientes: Nombre, dirección, país y ciudad de residencia e información de contacto relacionados con preguntas inquietudes y/o reclamos; entre otras. En todo caso, al momento de obtener la Autorización del Titular se le informará de manera específica los Datos Personales objeto del tratamiento.</p><p>El Titular de los datos al registrarse en el Sitio Web de ETERNA y/o hacer uso del mismo otorgará su consentimiento libre y voluntario para que el tratamiento se realice en los términos establecidos en el Aviso de Privacidad que se ponga a su disposición. En el entendido de que si el Usuario decidiera no proporcionar información obligatoria, este no podrá acceder a los servicios que efectivamente requieren de dicha información, sin embargo, podrá tener acceso a todos los demás servicios que no requieran dicha información.</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseFive><h4 class=section-subtitle>Medios y procedimiento para la actualización de la política</h4></a></h4></div><div id=collapseFive class=\"panel-collapse collapse\"><div class=panel-body><p>La presente Política será el medio para la notificación de cambios o actualizaciones, el cual estará publicado en <a href=https://eterna.com.co/wp-content/themes/eterna/pdf/politica_de_tratamiento_de_datos_eterna.pdf target=_blank>https://eterna.com.co/wp-content/themes/eterna/pdf/politica_de_tratamiento_de_datos_eterna.pdf</a></p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseSix><h4 class=section-subtitle>Derechos de los titulares</h4></a></h4></div><div id=collapseSix class=\"panel-collapse collapse\"><div class=panel-body><p>De conformidad con la Ley 1581 de 2012 y las normas que la reglamenten, complemente, adicionen y/o modifiquen, los Titulares de los Datos Personales que reposen en las Bases de Datos de ETERNA tendrán los siguientes derechos y los demás que consagre la regulación local aplicable:</p><ul id=tyc_list><li>Conocer, actualizar y rectificar sus Datos Personales. Pudiendo ejercer este derecho, entre otros frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o aquellos cuyo Tratamiento esté expresamente prohibido o no haya sido autorizado.</li><li>Solicitar prueba de la Autorización otorgada salvo cuando expresamente se exceptúe como requisito para el Tratamiento, según lo establezcan las normas aplicables.</li><li>Ser informado, previa solicitud, respecto del uso que le ha dado a sus Datos Personales y Datos Personales Sensibles.</li><li>Presentar ante la SIC quejas por infracciones a lo dispuesto en la ley y las demás normas que la modifiquen, adicionen o complementen.</li><li>Revocar la Autorización y/o solicitar la supresión del dato cuando en el Tratamiento no se respeten los principios, derechos y garantías constitucionales y legales. La revocatoria y/o supresión procederá cuando la SIC haya determinado que en el tratamiento se ha incurrido en conductas contrarias a la regulación aplicable.</li><li>Acceder en forma gratuita, según lo establecido en las normas aplicables, a sus Datos Personales y Datos Personales Sensibles que hayan sido objeto de Tratamiento.</li></ul><p>Así mismo, son derechos de los Titulares, todos los demás que señala la Ley y la Constitución Nacional.</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseSeven><h4 class=section-subtitle>Áreas responsables de la atención de peticiones, consultas y reclamos ante la cual el titular de la información puede ejercer sus derechos a conocer, actualizar, rectificar y suprimir el dato y revocar la autorización.</h4></a></h4></div><div id=collapseSeven class=\"panel-collapse collapse\"><div class=panel-body><p>Dependiendo del tipo del información personal tratada, el área encargada de la atención de peticiones, consultas y reclamos ante la cual el titular de la información puede ejercer sus derechos de conocer, actualizar, rectificar y suprimir el dato y revocar la autorización es:</p><h4 class=section-subtitle>Áreas encargadas:</h4><p>Queja o Reclamo: <a href=mailto:gcalidad@eterna.com.co>gcalidad@eterna.com.co</a>; <a href=mailto:info@eterna.com.co>info@eterna.com.co</a><br>Sugerencia: <a href=mailto:info@eterna.com.co>info@eterna.com.co</a><br>Solicitud de información: <a href=mailto:info@eterna.com.co>info@eterna.com.co</a><br>Trabaje con nosotros: <a href=mailto:seleccion@eterna.com.co>seleccion@eterna.com.co</a><br>Otros: <a href=mailto:info@eterna.com.co>info@eterna.com.co</a><br>Fichas tecnicas: <a href=mailto:info@eterna.com.co>info@eterna.com.co</a></p><p>Teléfono: (57) 027 27 Extensión 210</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseEight><h4 class=section-subtitle>Procedimiento para que los titulares de la información puedan ejercer los derechos a conocer, actualizar, rectificar y suprimir información y/o revocar la autorización</h4></a></h4></div><div id=collapseEight class=\"panel-collapse collapse\"><div class=panel-body><h4 class=section-subtitle>Consultas</h4><p>El Titular o su representante, podrá consultar la información personal del Titular entregada a ETERNA, para lo cual deberá formular una solicitud por el medio habilitado por ETERNA.</p><p>ETERNA deberá atender la consulta en un término máximo de diez (10) días hábiles contados a partir de la fecha de recibo de la misma; cuando no fuere posible atender la consulta dentro de dicho término, se informará al interesado, expresando los motivos de la demora y señalando la fecha en que se atenderá su consulta, la cual en ningún caso podrá superar los cinco (5) días hábiles siguientes al vencimiento del primer término.</p><h4 class=section-subtitle>Reclamos</h4><p>El Titular o su representante podrán solicitar la corrección, actualización o supresión, presentando un reclamo el cual deberá ser tramitado mediante solicitud escrita que contenga los siguientes datos:</p><ul id=tyc_list><li>Identificación del Titular</li><li>Descripción de los hechos que dan lugar al reclamo</li><li>Dirección de correspondencia del Titular</li><li>Documentos soporte de la solicitud</li></ul><p>ETERNA requerirá al interesado dentro de los cinco (5) días siguientes a la recepción del reclamo para que aporte documentos adicionales, en los casos en que resulte incompleta la solicitud.</p><p>Dentro de los dos (2) meses siguientes a la fecha del requerimiento sin que el solicitante presente la información requerida, se entenderá que ha desistido del reclamo. Recibido el reclamo, se incluirá dentro de los dos (2) días siguientes a la recepción del reclamo una nota dentro de la base de datos respectiva, en donde se establezca que un reclamo se encuentra en curso.</p><p>ETERNA o quien corresponda atenderá el reclamo dentro de los quince (15) días hábiles siguientes contados a partir del día siguiente a la fecha de su recibo. En caso de no ser posible atenderlo en ese término, se informará al interesado, y se informarán las razones de la demora, y se dará respuesta en un término de máximo ocho (8) días.</p><p>Los Titulares podrán en todo momento rectificar, conocer y actualizar sus datos, entre otros, frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o aquellos cuyo tratamiento esté expresamente prohibido o no haya sido autorizado. De conformidad con la Ley, ETERNA podrá negar el acceso a los Datos Personales, o la revocatoria de la autorización, o la solicitud de supresión de un dato en los siguientes casos:</p><ol type=a><li>Cuando el solicitante no sea el Titular de los Datos Personales, o el causahabiente, o el representante legal no esté debidamente acreditado para ello;</li><li>Cuando el solicitante no sea una entidad pública o administrativa en ejercicio de sus funciones legales, o no medie orden judicial.</li><li>Cuando el Titular tenga un deber legal de permanecer en la base de datos.</li><li>Cuando en su base de datos, no se encuentren los datos personales del solicitante;</li><li>Cuando se lesionen los derechos de un Tercero;</li><li>Cuando exista un impedimento legal, o la resolución de una autoridad competente, que restrinja el acceso o los datos personales, o no permita la rectificación, cancelación u oposición de los mismos;</li><li>Cuando la rectificación, cancelación u oposición haya sido previamente realizada.</li></ol></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseNine><h4 class=section-subtitle>Medidas de seguridad implementadas para conservar la privacidad y protección de datos personales</h4></a></h4></div><div id=collapseNine class=\"panel-collapse collapse\"><div class=panel-body><p>ETERNA implementa medidas precautorias administrativas, técnicas y físicas para resguardar la Información Personal del Titular de pérdidas, robos, o uso indebidos así como del acceso, la divulgación, modificación o destrucción no autorizados.</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseTen><h4 class=section-subtitle>Transferencia y/o transmisión de información personal</h4></a></h4></div><div id=collapseTen class=\"panel-collapse collapse\"><div class=panel-body><p>Los Datos Personales de los Titulares podrán ser Transmitidos o Transferidos a empresas vinculadas, subordinadas y/o afiliadas de ETERNA, empresas que podrán estar localizadas en países diferentes a Colombia que ofrezcan niveles diferentes de protección de datos personales a los establecidos en Colombia. La información que sea objeto de Transferencia o Transmisión podrá ser utilizada para diversos objetivos comerciales, enviar publicidad a los Usuarios de acuerdo a sus intereses específicos, y otras actividades que ETERNA considere apropiadas. ETERNA también podrá revelar información cuando por mandato de ley y/o de autoridad competente le fuere requerido o por considerar de buena fe que dicha revelación es necesaria para: I) cumplir con procesos legales; II) responder reclamaciones que involucren cualquier Contenido que menoscabe derechos de terceros o; III) proteger los derechos, la propiedad, o la seguridad de ETERNA, sus Usuarios y el público en general. En cualquier caso, los Avisos de Privacidad o Autorizaciones respectivas, informarán al Titular sobre la Transferencia o Transmisión de sus Datos Personales. En todo caso ETERNA garantiza la seguridad y confidencialidad de la Información Personal.</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseEleven><h4 class=section-subtitle>Término de almacenamiento de la información personal recolectada por eterna</h4></a></h4></div><div id=collapseEleven class=\"panel-collapse collapse\"><div class=panel-body><p>Cuando la Información Personal recolectada deje de ser necesaria para el cumplimiento de las finalidades previstas en la presente Política, en el respectivo Aviso de Privacidad o en la Autorización y en las disposiciones jurídicas aplicables, los Datos Personales serán eliminados de la Base de Datos de ETERNA</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseTwelve><h4 class=section-subtitle>Cambios de la política de tratamiento de datos de eterna</h4></a></h4></div><div id=collapseTwelve class=\"panel-collapse collapse\"><div class=panel-body><p>ETERNA se reserva el derecho de efectuar, modificaciones a la presente Política, que rige a partir de su publicación. De conformidad a lo establecido en el artículo 5 del Decreto 1377 de 2013, cuando se presenten cambios sustanciales, referidos a la identificación del responsable y a la finalidad del Tratamiento, los cuales afecten el contenido de la autorización será necesario comunicar dichos cambios al Titular. Además, ETERNA obtendrá del titular una nueva autorización cuando el cambio se refiera a la finalidad del tratamiento.</p></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a href=javascript:; data-toggle=collapse data-parent=#accordion_tratamiento_datos data-target=#collapseThirteen><h4 class=section-subtitle>Información de niños y/o adolescentes menores de 18</h4></a></h4></div><div id=collapseThirteen class=\"panel-collapse collapse\"><div class=panel-body><p>ETERNA no recolecta Información proveniente de Usuarios menores de 18, sin embargo, cuando se obtengan Datos Personales de niños, niñas y adolescentes, se obtendrá la Autorización de los padres o tutor del menor.</p></div></div></div></div><p class=text-center>Esta Política fue revisada y ajustada por última vez en abril de 2018. La misma se encuentra vigente desde julio de 2013.</p></div></div><div class=clearfix></div><div class=bottom-space></div></div>");
$templateCache.put("app/main/templates/directives/app-footer.html","<div class=\"app-footer navbar fixed-bottom\"><div class=container-fluid><div id=footer-logo class=\"col-12 col-sm-3 col-md-2 justify-content-center\"><a class=navbar-brand ui-sref=private.home><img src=assets/images/logo_eterna.png border=0></a></div><div id=footer-text-center class=\"col-12 col-sm-4 justify-content-center\"><p class=\"white-color text-center\">Av Calle 26 No 57-83 Torre 7 Piso 4 PBX (571) 5702727 - (571) 2601100<br>&copy; Copyright 2016 Eterna S.A. Todos los derechos reservados</p></div><div id=footer-btns-container class=\"col-12 col-sm-6 col-md-6 justify-content-center\"><div class=\"col-md-5 text-center\"><button ng-click=goTratamientoDatos() class=\"btn btn-sm btn-custom-light-gray btn-inline-block\">Tratamiento de datos y protección de datos</button></div><div class=\"col-md-1 text-center\"></div><div class=\"col-md-5 text-center\"><button ng-click=goAvisoPrivacidad() class=\"btn btn-sm btn-custom-light-gray btn-inline-block\">Aviso de privacidad, cargar la documentos</button></div></div></div></div>");
$templateCache.put("app/main/templates/directives/app-header.html","<div class=\"app-header navbar navbar-expand-md fixed-top\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#bs-example-navbar-collapse-1 aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=private.home><img src=assets/images/logo_eterna.png border=0></a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-1><ul class=\"nav navbar-nav\"><li ng-if=\"isAuthenticated && isSiteEnable\"><a class=nav-link ui-sref=private.home ui-sref-active=active><i class=\"fas fa-tag\"></i> Productos <i class=\"fas fa-angle-down down\"></i></a></li><li ng-if=\"isAuthenticated && isSiteEnable\"><a class=nav-link ui-sref=private.shoppingcar ui-sref-active=active><i class=\"fas fa-shopping-cart\"></i> Carrito <i class=\"fas fa-angle-down down\"></i></a></li><li ng-if=\"isAuthenticated && isSiteEnable\"><a class=nav-link ui-sref=private.orders ui-sref-active=active><i class=\"fas fa-list-ul\"></i> Historial <i class=\"fas fa-angle-down down\"></i></a></li><li ng-if=\"isAuthenticated && isSiteEnable\"><a class=nav-link ui-sref=private.profile ui-sref-active=active><i class=\"fas fa-user\"></i> Mi cuenta <i class=\"fas fa-angle-down down\"></i></a></li><li ng-if=\"isAuthenticated && isSiteEnable\"><a class=nav-link ui-sref=private.terms ui-sref-active=active><i class=\"fas fa-check\"></i> Términos <i class=\"fas fa-angle-down down\"></i></a></li></ul><ul class=\"nav navbar-nav\"><li ng-if=\"isAuthenticated && isSiteEnable\"><a class=nav-link ng-click=logoutAlert()><i class=\"fas fa-times-circle\"></i> Salir</a></li><li ng-if=\"!isAuthenticated && isSiteEnable\"><a class=nav-link ui-sref=public.login ui-sref-active=active>Login</a></li></ul></div><!--<a class=\"navbar-brand\" ui-sref=\"private.home\">\n	    	<img src=\"assets/images/logo_eterna.png\" border=\"0\">\n	    </a>\n	    <button class=\"navbar-toggler collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n		    <span class=\"navbar-toggler-icon\"></span>\n		</button>\n		<div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n		    <ul class=\"navbar-nav mr-auto\">\n		      <li ng-if=\"isAuthenticated\" class=\"nav-item\">\n		        <a class=\"nav-link\" ui-sref=\"private.home\" ui-sref-active=\"active\"><i class=\"fas fa-tag\"></i> Productos</a>\n		      </li>\n		      <li ng-if=\"isAuthenticated\" class=\"nav-item\">\n		        <a class=\"nav-link\" ui-sref=\"private.shoppingcar\" ui-sref-active=\"active\"><i class=\"fas fa-shopping-cart	\"></i> Carrito</a>\n		      </li>\n		      <li ng-if=\"isAuthenticated\" class=\"nav-item\">\n		        <a class=\"nav-link\" ui-sref=\"private.orders\" ui-sref-active=\"active\"><i class=\"fas fa-list-ul\"></i> Historial</a>\n		      </li>\n		      <li ng-if=\"isAuthenticated\" class=\"nav-item\">\n		        <a class=\"nav-link\" ui-sref=\"private.profile\" ui-sref-active=\"active\"><i class=\"fas fa-user\"></i> Mi cuenta</a>\n		      </li>\n		      <li ng-if=\"!isAuthenticated\" class=\"nav-item\">\n		      	<a class=\"nav-link\" ui-sref=\"public.login\" ui-sref-active=\"active\">Login</a>\n		      </li>\n		    </ul>\n		    <ul class=\"navbar-nav ml-auto\">\n		    	<li ng-if=\"isAuthenticated\" class=\"nav-item\">\n                    <a class=\"nav-link\" ng-click=\"logout()\"><i class=\"fas fa-times-circle\"></i> Salir</a>\n                </li>\n		    </ul>\n		</div>--></div></div>");
$templateCache.put("app/main/templates/directives/loading.html","<div class=loading-blocker ng-class=\"{\'display-as-row\': displayasrow, \'display-inline\': !block, \'display-block\': block, \'has-background\': hasbackground }\"><div class=loader-container><i class=\"fa fa-spinner fa-spin fa-pulse fa-{{ size }}\"></i></div></div>");
$templateCache.put("app/main/templates/directives/logout-alert.html","<div class=alert-msg-center>¿Estás seguro que deseas salir de éste sitio web?</div><div class=\"alert-footer text-center\"><button ng-click=closeThisDialog() class=\"btn btn-custom-light-gray btn-sm btn-inline-block\">Cancelar</button> <button ng-click=logout() class=\"btn btn-custom btn-sm btn-inline-block\">Salir del sitio web</button></div>");
$templateCache.put("app/main/templates/directives/order-details.html","<div class=\"col-10 order-details-content\"><div class=\"full-width hidden-xs\"><h6 class=details-title>Detalle del envío</h6><div class=row><div class=col-3><strong>Enviado a:</strong> {{order.user.full_name}}</div><div class=col-4><strong>Fecha de envío:</strong> {{order.created_at}}</div></div><div class=row><div class=col-3><strong>Contenido</strong></div></div><div class=row ng-repeat=\"product in order.products\"><div class=col-3>{{product.info.title}} <span ng-repeat=\"attribRef in product.infoReference.main_attributes\">{{attribRef.name}}: {{attribRef.valores[0].value_attrib}} </span><br>Ref: {{product.infoReference.sku}}</div><div class=col-4>{{product.total_price}}</div></div></div><div class=\"full-width visible-xs\" style=\"margin-top: 10px\"><h6 class=item-data-title>Detalle del envío</h6><p class=\"item-data-value small\"><strong>Enviado a:</strong> {{order.user.full_name}}<br><strong>Fecha de envío:</strong> {{order.created_at}}</p><h6 class=item-data-title>Contenido</h6><p class=\"item-data-value small\" ng-repeat=\"product in order.products\">{{product.info.title}} <span ng-repeat=\"attribRef in product.infoReference.main_attributes\">{{attribRef.name}}: {{attribRef.valores[0].value_attrib}} </span>(Ref: {{product.infoReference.sku}}): ${{product.total_price}}</p></div></div>");
$templateCache.put("app/main/templates/directives/product-item.html","<div class=product-small-item><a ui-sref=\"private.productDetails({id: {{product.id}}, page: {{page}}})\"><div class=product-image><img ng-if=product.url ng-src={{product.url}} class=img-fluid> <img ng-if=!product.url src=assets/images/without-product-pic.png class=img-fluid></div></a><div class=product-info><a ui-sref=\"private.productDetails({id: {{product.id}}, page: {{page}}})\"><span class=product-name>{{product.title}}</span></a><p class=product-price><a ui-sref=\"private.productDetails({id: {{product.id}}, page: {{page}}})\">{{product.price | currency:\"$\":0}}</a></p><div class=\"row attributes-row\" ng-if=!product.attributes.length></div><div class=\"row attributes-row\" ng-if=product.attributes.length><div class=\"col-6 col-sm-6\" ng-repeat=\"attribute in product.attributes\"><label>{{attribute.name}}</label><select class=\"form-control purple-border-bold custom-select custom-select-purple\" name=product_attr_{{attribute.id}} ng-model=attributesChoosed[$index].valor><option value={{attributeValues.id}} ng-repeat=\"attributeValues in attribute.valores\">{{attributeValues.value_attrib}}</option></select></div></div><div class=row><div class=\"col-12 col-sm-12 text-right\"><a ui-sref=private.shoppingcar ng-if=\"product.itemsInShoppingCart > 0\" class=purple-color><span ng-if=\"product.itemsInShoppingCart > 0\" class=\"fas fa-shopping-cart purple-color\"></span> {{product.itemsInShoppingCart}}</a> <button type=button class=\"btn btn-sm btn-inline-block btn-custom\" ng-disabled=isAdding ng-click=addShoppingCart()><span ng-if=\"!isAdded && !isAdding\">Añadir</span> <span ng-if=\"isAdded && !isAdding\">Añadido</span> <span ng-if=isAdding class=\"fas fa-spinner\"></span></button></div></div></div></div>");
$templateCache.put("app/main/templates/layouts/private.html","<div class=\"app app-private\"><app-header></app-header><div ui-view=container></div><app-footer></app-footer></div>");
$templateCache.put("app/main/templates/layouts/public.html","<div class=\"app app-public container\"><app-header></app-header><div ui-view=container></div><app-footer></app-footer></div>");}]);